/* eslint-disable no-control-regex */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect, useMemo, useCallback } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Input,
  ListItemText,
  MenuItem,
  Typography,
  Tooltip,
} from '@material-ui/core'
import useStyles from './editDetailsStyles'
import { FormattedMessage, useIntl } from 'react-intl'
import CancelButton from 'app/components/buttons/CancelButton'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import Formsy from 'formsy-react'
import { TextInput } from 'app/components/FormsyHelperComponent'
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined'
import PhoneNumberInputFormsy, {
  validatePhoneNumber,
} from 'app/components/PhoneNumberInputFormsy'
import { parsedPhoneNumber } from 'commons/phoneNumber'
import clsx from 'clsx'
import GroupSelectCrm from 'app/components/GroupSelectCrm'
import { SelectFormsy } from '@fuse'
import transformCrmFields from './crmFields'
import CloseIcon from '@material-ui/icons/Close'
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined'
import EditLocationOutlinedIcon from '@material-ui/icons/EditLocationOutlined'
import ContactMailOutlinedIcon from '@material-ui/icons/ContactMailOutlined'
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined'
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined'
import MaterialUIPickers from 'app/components/datepickers/MaterialUIPickers'
import { useSelector } from 'react-redux'
import CountryList from './CountryList'
import NationalityList from './NationalityList'
import GenderList from './GenderList'
import OccupationList from './OccupationList'
import moment from 'moment'
import TextField from '@material-ui/core/TextField'
import effects from 'app/effects/effects'
import PersonAvatar from 'app/components/PersonAvatar'
import * as R from 'ramda'
import CustomContactForm from './customFields/customContactForm'
import CustomAddressForm from './customFields/customAddressForm'
import { v4 as uuidv4 } from 'uuid'
import {
  GENERAL,
  CONTACT,
  PHYSICAL_ADDRESS,
  MAILING_ADDRESS,
  SOCIAL_INFORMATION,
  SHIPPING_ADDRESS,
  BILLING_ADDRESS,
  PHONE_NUMBER,
  TEXT,
} from './customFields/constants'
import AddressFields from './addressFields'
import ConfirmDeleteCustomFieldPopup from './confirmDeleteCustomFieldPopup'
import CustomSocialForm from './customFields/customSocialForm'
import { isValidEmail } from 'libs/text'
import _ from '@lodash'
import CustomFieldForm from './customFields/customFieldForm'
import { useAppName } from 'commons/usePartner'
import {
  PLACE_INVITATION_ACCEPT_REQUEST,
  PLACE_INVITATION_ACCEPT_INVITATION,
  PLACE_INVITATION_PUBLIC_SUBSCRIBE,
  PLACE_INVITATION_REMOVE_SUBSCRIPTION,
  PLACE_INVITATION_UNSUBSCRIBED,
} from 'app/configs/statusConfigs'
import StatusChips from 'app/components/StatusChips'
import {
  CONTACT_TYPE_APP,
  CONTACT_TYPE_REGISTERED,
  CONTACT_TYPE_CRM,
  CONTACT_TYPE_OTHET,
} from 'app/main/notification/socialMediaSelect/socialMediaSelectConfig'
import { CHANNEL_SMS, CHANNEL_EMAIL, CHANNEL_CALL } from 'app/constants/channel'
import Assets from 'app/configs/assetConfigs'
import { useFlag } from '@unleash/proxy-client-react'
import StatefulSelector, {
  validateRequired,
} from 'app/components/selector/StatefulSelector'
import useLanguage from 'app/components/selector/useLanguage'
import LanguageRenderItem from 'app/components/selector/LanguageRenderItem'
import { ProgressWithText } from 'app/components/progress/ProgressWithText'
import { usePlace } from 'commons/usePlace'

const DEFAULT_AVATAR_PATH = 'assets/images/avatars/profile.jpg'
const MAX_LENGTH = 50
let newTags = []
let isRendered = false
let isFirstTimeRendered = false

const textLabelResticted = () => {
  return (
    <label className="font-bold">
      (<FormattedMessage id="notification.channel.restricted" />)
    </label>
  )
}

export default (props) => {
  const {
    subscriber,
    updateCrmFields,
    isHideGroup,
    openOrCloseEditDetailsDialog,
    isQuickAction,
  } = props

  const mes_248_remove_additional_phone_fields = useFlag(
    'mes_248_remove_additional_phone_fields',
  )
  const countryList = useSelector(({ countries }) => countries.countryList)
  const statePhysicalList = useSelector(
    ({ statePhysical }) => statePhysical.statePhysicalList,
  )
  const stateMailingList = useSelector(
    ({ stateMailing }) => stateMailing.stateMailingList,
  )
  const { getAllLanguage } = useLanguage()
  const place = usePlace()

  const isUnsubscribed =
    subscriber.lastInvitationStatus === PLACE_INVITATION_REMOVE_SUBSCRIPTION ||
    subscriber.lastInvitationStatus === PLACE_INVITATION_UNSUBSCRIBED

  const crmFields = transformCrmFields(
    subscriber,
    countryList,
    statePhysicalList,
    stateMailingList,
  )
  const isSubscribed = R.includes(subscriber.lastInvitationStatus, [
    PLACE_INVITATION_ACCEPT_REQUEST,
    PLACE_INVITATION_ACCEPT_INVITATION,
    PLACE_INVITATION_PUBLIC_SUBSCRIBE,
  ])
  const { formatMessage } = useIntl()
  const isHideContacts = Boolean(R.prop('hideContacts', subscriber))

  const [crmCustomfields, setCrmCustomfields] = useState({
    ...subscriber.customFields,
  })
  const appName = useAppName()
  const appLabel = formatMessage(
    {
      id: 'crm.form.notificationMethod.app',
    },
    {
      appName,
    },
  )

  const [preferSelector, setPreferSelector] = useState(
    R.compose(
      R.filter((item) => {
        return isSubscribed ? item.isVerified === 1 : true
      }),
      R.map((item) => {
        if (item.contactType === CONTACT_TYPE_APP) {
          item.contact = appLabel
        }
        return item
      }),
      R.sortWith([
        R.ascend(R.prop('contactType')),
        R.ascend(R.prop('channel')),
      ]),
      R.prop('receiveMethods'),
    )(subscriber),
  )

  const { selectedPlace } = useSelector(({ auth }) => auth.user)
  const isDisplayCareCheck = selectedPlace.info.shouldSeeCarecheck
  const styleClass = useStyles()

  let initDataDialogState = {
    isDisabledBtn: true,
    avatarBase64: crmFields.avatar || DEFAULT_AVATAR_PATH,
    avatar: crmFields.avatar || subscriber.avatarCharacters,
    fullName: crmFields.fullName,
    isFormValid: true,
    isSetHeight: false,
    isTranslated: false, //crmFields.isTranslated
    fromButton: false,
    errors: {},
  }

  const [dialogState, setDialogState] = useState({
    ...initDataDialogState,
  })
  const [isDisabledForm, setDisabledForm] = useState(false)

  const [isInvalidPhone, setIsInvalidPhone] = useState(null)
  const [isInvalidPrefer, setIsInvalidPrefer] = useState(null)

  const [openDeleteCustomField, setOpenDeleteCustomField] = useState(null)
  const [phoneListState, setPhoneListState] = useState({
    countryCode: crmFields.countryCode,
    phoneNumber: crmFields.phoneNumber,
    automatedCallPhoneNumber: crmFields.automatedCallPhoneNumber,
    automatedCallCountryCode: crmFields.automatedCallCountryCode,
  })
  const [customLabels, setCustomLabels] = useState({
    [GENERAL]: [],
    [CONTACT]: [],
    [PHYSICAL_ADDRESS]: [],
    [MAILING_ADDRESS]: [],
    [SOCIAL_INFORMATION]: [],
    [SHIPPING_ADDRESS]: [],
    [BILLING_ADDRESS]: [],
  })
  const [changedCustomCrmFields, setChangedCustomCrmFields] = useState({
    [GENERAL]: {},
    [CONTACT]: {},
    [PHYSICAL_ADDRESS]: {},
    [MAILING_ADDRESS]: {},
    [SOCIAL_INFORMATION]: {},
    [SHIPPING_ADDRESS]: {},
    [BILLING_ADDRESS]: {},
  })
  const phoneNumberRef = useRef(null)

  const hasApp = R.prop('activeMobileUser', subscriber)

  const handleCustomfields = (fieldId, method) => {
    const remainedItems = crmCustomfields[method].filter(
      (item) => item.id !== fieldId,
    )
    setCrmCustomfields({
      ...crmCustomfields,
      [method]: remainedItems,
    })

    setDialogState({
      ...dialogState,
      isDisabledBtn: false,
    })
  }

  const handleDeleteCRMCustomfield = (fieldId, method) => {
    effects.apis
      .deleteSubscribersCRMCustomField({
        subscriberId: subscriber.id,
        fieldId: fieldId,
      })
      .then((res) => {
        handleCustomfields(fieldId, method)
      })
  }

  const updateCustomFieldsContentData = ({
    value,
    method,
    id,
    isLocal,
    labelType,
  }) => {
    let updatedMethod = isLocal ? customLabels[method] : crmCustomfields[method]
    let currentUpdatedFieldIndex = updatedMethod.findIndex(
      (item) => item.id === id || item.localId === id,
    )

    //find already existed item
    let currentUpdatedField = updatedMethod.find(
      (item) => item.id === id || item.localId === id,
    )

    //create new item for current method
    updatedMethod[currentUpdatedFieldIndex] = {
      ...updatedMethod[currentUpdatedFieldIndex],
      content: value,
    }

    //update existed item's content
    currentUpdatedField = {
      ...currentUpdatedField,
      content: value,
    }

    isLocal &&
      setCustomLabels({
        ...customLabels,
        [method]: [...updatedMethod],
      })

    !isLocal &&
      setChangedCustomCrmFields({
        ...changedCustomCrmFields,
        [method]: {
          ...changedCustomCrmFields[method],
          [id]: { ...currentUpdatedField },
        },
      })
  }

  const updateCustomAddressFieldData = ({
    currentValue,
    addressDataId,
    labelName,
    labelMethod,
    isLocal,
    countryCode,
    countryId,
    regionType,
  }) => {
    let currentCustomFieldsData
    let currentUpdatedIndex

    if (isLocal) {
      currentCustomFieldsData = [...customLabels[labelMethod]]
      currentUpdatedIndex = currentCustomFieldsData.findIndex(
        (item) => item.localId === addressDataId,
      )
    } else {
      currentCustomFieldsData = [...crmCustomfields[labelMethod]]
      currentUpdatedIndex = currentCustomFieldsData.findIndex(
        (item) => item.id === addressDataId,
      )
    }

    const indexOfCurrentLabel = currentCustomFieldsData[currentUpdatedIndex][
      'subFields'
    ].findIndex((item) => item.label === labelName)
    let updatedCurrentLabel = {
      ...currentCustomFieldsData[currentUpdatedIndex]['subFields'][
        indexOfCurrentLabel
      ],
      content: currentValue,
      physicalCountryCode: countryCode && countryCode,
      physicalCountryId: countryId && countryId,
      physicalRegionType: regionType && regionType,
    }

    currentCustomFieldsData[currentUpdatedIndex]['subFields'][
      indexOfCurrentLabel
    ] = {
      ...updatedCurrentLabel,
    }

    if (labelName === 'Province') {
      currentCustomFieldsData[currentUpdatedIndex]['customAttributes'] = {
        region: {
          countryId: countryId,
          provinceId: currentValue,
          regiontype: regionType,
        },
      }
    }
    currentCustomFieldsData[currentUpdatedIndex][
      'customAttributes'
    ].physicalCountryCode = countryCode
    if (isLocal) {
      setCustomLabels({
        ...customLabels,
        [labelMethod]: currentCustomFieldsData,
      })
    } else {
      setChangedCustomCrmFields({
        ...changedCustomCrmFields,
        [labelMethod]: currentCustomFieldsData,
      })
    }
  }

  const deleteCustomLocalLabel = (currentItemlocalId, method) => {
    const remainedItems = customLabels[method].filter(
      (item) => item.localId !== currentItemlocalId,
    )
    setCustomLabels({
      ...customLabels,
      [method]: remainedItems,
    })
  }

  const saveCustomLabel = (data, method) => {
    const updatedField = customLabels[method].concat({
      ...data,
      localId: uuidv4(),
      content: '',
      customAttributes: { labelType: data.labelType },
    })
    setCustomLabels({
      ...customLabels,
      [method]: updatedField,
    })
  }

  const [formFields, setFormFields] = useState({
    dateOfBirth: crmFields.crmBirthday || null,
    passportExpiresAt: crmFields.passportExpiresAt || null,
    jobTitle: crmFields.jobTitle,
    physicalCountryCode: crmFields.physicalCountry['code'],
    mailingCountryCode: crmFields.mailingCountry['code'],
    physicalRegionType: crmFields.physicalCountry['regionType'],
    mailingRegionType: crmFields.mailingCountry['regionType'],
    physicalCountryId: crmFields.physicalCountry['id'],
    mailingCountryId: crmFields.mailingCountry['id'],
    physicalCityName: crmFields.physicalCityName,
    mailingCityName: crmFields.mailingCityName,
    firstName: crmFields.firstName,
    middleName: crmFields.middleName,
    lastName: crmFields.lastName,
    isFullNameChanged: false,
    phoneticFirstName: crmFields.phoneticFirstName,
    phoneticMiddleName: crmFields.phoneticMiddleName,
    phoneticLastName: crmFields.phoneticLastName,
    preferedContact: crmFields.preferedContact,
    email: crmFields.email,
  })

  useEffect(() => {
    newTags = crmFields.tags
    setPhoneListState((prevState) => ({
      ...prevState,
      mobileCountryCode: crmFields.mobileCountryCode,
      mobilePhoneNumber: crmFields.mobilePhoneNumber,
      otherCountryCode: crmFields.otherCountryCode,
      otherPhoneNumber: crmFields.otherPhoneNumber,
      officeCountryCode: crmFields.officeCountryCode,
      officePhoneNumber: crmFields.officePhoneNumber,
      homeCountryCode: crmFields.homeCountryCode,
      homePhoneNumber: crmFields.homePhoneNumber,
      faxCountryCode: crmFields.faxCountryCode,
      faxPhoneNumber: crmFields.faxPhoneNumber,
    }))

    isRendered = false
    isFirstTimeRendered = false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [preferedContact, setPreferedContact] = useState(
    R.compose(R.prop('id'), R.find(R.prop('isSelected')))(preferSelector),
  )

  function disableOrAbleSaveBtn(bool = false) {
    if (dialogState.isDisabledBtn || bool) {
      setDialogState({
        ...dialogState,
        isDisabledBtn: bool,
      })
    }
  }

  function handleFormChange(data) {
    let errorFields = Object.keys(dialogState.errors)
    let errorList = dialogState.errors

    errorFields.forEach((fieldName) => {
      let value = data[fieldName] && data[fieldName].replace(/\s/g, '').trim()
      if (value) {
        delete errorList[fieldName]
      }
    })

    setDialogState({
      ...dialogState,
      errors: errorList,
      isDisabledBtn: false,
    })
  }

  async function handleEditDetails(fields) {
    if (dialogState.isUploadFile && dialogState.avatar) {
      fields.crmAvatar = dialogState.avatar
      delete fields.uploadField
    }

    let finalUpdatedCustomfields = {
      [GENERAL]: [],
      [CONTACT]: [],
      [PHYSICAL_ADDRESS]: [],
      [MAILING_ADDRESS]: [],
      [SOCIAL_INFORMATION]: [],
      [SHIPPING_ADDRESS]: [],
      [BILLING_ADDRESS]: [],
    }
    // eslint-disable-next-line no-unused-vars
    for (let item in finalUpdatedCustomfields) {
      finalUpdatedCustomfields[item].push(...customLabels[item])
      !R.isNil(crmCustomfields[item]) &&
        finalUpdatedCustomfields[item].push(...crmCustomfields[item])
    }

    let newFields = {
      ...fields,
      ...phoneListState,
      customFields: { ...finalUpdatedCustomfields },
      tags: newTags,
      passportCountryCode: fields.passportCountryCode.toString(),
      nationality: fields.nationality.toString(),
      preferLanguage: fields.preferLanguage.id,
    }

    if (formFields.dateOfBirth) {
      let dateFormat = new Date(
        moment(formFields.dateOfBirth).format('YYYY-MM-DD'),
      ).toISOString()
      newFields['birthday'] = dateFormat
      newFields['crmBirthday'] = dateFormat
    }

    if (formFields.passportExpiresAt) {
      newFields['passportExpiresAt'] = new Date(
        moment(formFields.passportExpiresAt).format('YYYY-MM-DD'),
      ).toISOString()
    }
    newFields.jobTitle = formFields.jobTitle
    setDisabledForm(true)

    const receiveMethods = R.compose(
      R.pick(['id', 'channel', 'contact']),
      R.head,
      R.map((item) => {
        if (item.contactType === CONTACT_TYPE_REGISTERED && isHideContacts) {
          item.contact = null
        }
        if (R.includes(item.id, ['emailCrm', 'smsCrm', 'automatedCallCrm'])) {
          item.id = null
        }
        return item
      }),
      R.filter(R.propEq('id', preferedContact)),
      R.clone,
    )(preferSelector)
    newFields.selectedChannel = receiveMethods

    let res = await updateCrmFields(subscriber, newFields)
    if (res['details'] && res['details']) {
      let errorMsgs = {}
      if (res['details']['code'] && res['details']['code'] === 694) {
        errorMsgs = {
          carechekId: res['details']['message'],
        }
      } else if (res['details']['code'] && res['details']['code'] === 618) {
        errorMsgs = {
          uniqueId: res['details']['message'],
        }
      } else if (res['details']['message']['errors']) {
        errorMsgs = res['details']['message']['errors']
      } else {
        return
      }

      setDialogState({
        ...dialogState,
        isDisabledBtn: true,
        errors: errorMsgs,
      })
    } else {
      setDialogState({
        ...dialogState,
        isDisabledBtn: true,
        fullName:
          `${newFields.prefix} ${newFields.firstName} ${newFields.middleName} ${newFields.lastName} ${newFields.suffix}`.trim(),
      })
    }
    setDisabledForm(false)
  }

  const handlePreferSelector = (fullNumber, channels, badContact, id) => {
    if (R.isEmpty(fullNumber)) {
      const isSelectedCrm = R.compose(
        R.not,
        R.isNil,
        R.find((item) => {
          return (
            preferedContact === item.id &&
            item.contactType === CONTACT_TYPE_CRM &&
            item.channel === channels
          )
        }),
      )(preferSelector)

      if (isSelectedCrm) {
        setPreferedContact('')
      }

      setPreferSelector(
        R.filter((item) => {
          return R.not(
            item.contactType === CONTACT_TYPE_CRM && item.channel === channels,
          )
        }, preferSelector),
      )
    } else {
      const crmInSelector = R.find((item) => {
        return (
          item.contactType === CONTACT_TYPE_CRM &&
          R.includes(item.channel, [channels])
        )
      }, preferSelector)

      const phoneDuplicate = R.find((item) => {
        return (
          item.contactType === CONTACT_TYPE_CRM &&
          item.channel === channels &&
          item.contact === fullNumber
        )
      }, subscriber.receiveMethods)

      if (R.isNil(crmInSelector)) {
        setPreferSelector((prevState) => [
          ...prevState,
          R.isNil(phoneDuplicate)
            ? {
                id: id,
                contact: fullNumber,
                channel: channels,
                contactType: CONTACT_TYPE_CRM,
              }
            : phoneDuplicate,
        ])
      } else {
        if (crmInSelector.contact !== fullNumber) {
          setPreferSelector((prevState) =>
            R.map((item) => {
              if (
                item.contactType === CONTACT_TYPE_CRM &&
                R.equals(item.channel, channels)
              ) {
                item.contact = fullNumber
                item.isBadContact = badContact
              }
              return item
            }, prevState),
          )
        }
      }
    }
  }

  const handlePhoneNumber = (fullNumber, phoneType, badContact) => {
    let parsed = parsedPhoneNumber(fullNumber)
    if (fullNumber === '') {
      parsed = {
        countryCode: '',
        phoneNumber: '',
      }
    }

    if (parsed) {
      disableOrAbleSaveBtn()
      let phoneObj = {}
      if (phoneType === 'fullPhoneNumber') {
        handlePreferSelector(fullNumber, CHANNEL_SMS, badContact, 'smsCrm')
        phoneObj = {
          countryCode: parsed.countryCode,
          phoneNumber: parsed.phoneNumber,
        }
      } else if (phoneType === 'automatedCallFullPhoneNumber') {
        handlePreferSelector(
          fullNumber,
          CHANNEL_CALL,
          badContact,
          'automatedCallCrm',
        )
        phoneObj = {
          automatedCallCountryCode: parsed.countryCode,
          automatedCallPhoneNumber: parsed.phoneNumber,
        }
      } else if (phoneType === 'fullOtherMobileNumber') {
        phoneObj = {
          mobileCountryCode: parsed.countryCode,
          mobilePhoneNumber: parsed.phoneNumber,
        }
      } else if (phoneType === 'fullOtherPhoneNumber') {
        phoneObj = {
          otherCountryCode: parsed.countryCode,
          otherPhoneNumber: parsed.phoneNumber,
        }
      } else if (phoneType === 'fullOfficePhoneNumber') {
        phoneObj = {
          officeCountryCode: parsed.countryCode,
          officePhoneNumber: parsed.phoneNumber,
        }
      } else if (phoneType === 'fullHomePhoneNumber') {
        phoneObj = {
          homeCountryCode: parsed.countryCode,
          homePhoneNumber: parsed.phoneNumber,
        }
      } else if (phoneType === 'fullFaxNumber') {
        phoneObj = {
          faxCountryCode: parsed.countryCode,
          faxPhoneNumber: parsed.phoneNumber,
        }
      }

      setPhoneListState((prevState) => ({
        ...prevState,
        ...phoneObj,
      }))
    }
  }

  const handleTagsChange = (tags) => {
    disableOrAbleSaveBtn()
    newTags = tags
  }

  let avatarWrapper = (
    <div className={styleClass.formRowIconWrapper}>
      <TextInput
        className={styleClass.hide}
        id="upload-avatar"
        onChange={({ target }) => {
          if (target.files[0].type.match(/.(jpg|jpeg|png|gif)$/i)) {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(target.files[0])
            fileReader.onload = (e) => {
              setDialogState({
                ...dialogState,
                isUploadFile: true,
                avatar: e.target.result,
                isDisabledBtn: false,
              })
            }
          }
        }}
        accept="image/*"
        type="file"
        containerClassName="MuiFormControl-fullWidth"
        labelId="crm.upload.avatar"
        placeholderId="crm.upload.avatar"
        variant="standard"
        fullWidth
        name="uploadField"
      />

      <label htmlFor="upload-avatar" className={styleClass.formRowIconChoose}>
        <div className={styleClass.formRowIconChooseBg}>
          <PhotoCameraOutlinedIcon />
        </div>
        <PersonAvatar
          placeHolder={subscriber.avatarCharacters}
          alt={crmFields.fullName}
          subId={subscriber.id}
          src={dialogState.avatar}
          className={styleClass.avatarIcon}
          badgeClassName="w-full h-full"
        />
      </label>

      <div className={styleClass.formRowIconText}>
        {formatMessage({
          id: 'crm.form.setAProfilePhoto',
        })}
      </div>
    </div>
  )

  const setCity = (inputName, data) => {
    let terms = data['terms']
    if (terms && terms[terms.length - 2]) {
      let { value } = terms[terms.length - 2]
      setFormFields({
        ...formFields,
        [inputName]: value,
      })
    }
  }

  const setCustomCity = (inputName, data, { method, addressData, isLocal }) => {
    let terms = data['terms']
    let currentCustomFieldsData
    let currentUpdatedIndex

    if (isLocal) {
      currentCustomFieldsData = [...customLabels[method]]
      currentUpdatedIndex = currentCustomFieldsData.findIndex(
        (item) => item.localId === addressData.localId,
      )
    } else {
      currentCustomFieldsData = [...crmCustomfields[method]]
      currentUpdatedIndex = currentCustomFieldsData.findIndex(
        (item) => item.id === addressData.id,
      )
    }

    if (terms && terms[terms.length - 2]) {
      let cityLabel = 'City'
      let { value } = terms[terms.length - 2]
      const indexOfCurrentLabel = currentCustomFieldsData[currentUpdatedIndex][
        'subFields'
      ].findIndex((item) => item.label === cityLabel)
      let updatedCurrentLabel = {
        ...currentCustomFieldsData[currentUpdatedIndex]['subFields'][
          indexOfCurrentLabel
        ],
        content: value,
      }

      currentCustomFieldsData[currentUpdatedIndex]['subFields'][
        indexOfCurrentLabel
      ] = {
        ...updatedCurrentLabel,
      }

      if (isLocal) {
        setCustomLabels({
          ...customLabels,
          [method]: currentCustomFieldsData,
        })
      } else {
        setChangedCustomCrmFields({
          ...changedCustomCrmFields,
          [method]: currentCustomFieldsData,
        })
      }
    }
  }

  const handleValidForm = (isValid) => {
    if (dialogState.isFormValid !== isValid) {
      setDialogState({
        ...dialogState,
        isFormValid: isValid,
      })
    }
  }

  const TextFieldDateComponent = (props) => {
    return <TextField {...props} disabled={true} />
  }

  let isNameFilled = useMemo(
    () =>
      Boolean(formFields.firstName.trim()) &&
      Boolean(formFields.lastName.trim()),
    [formFields.firstName, formFields.lastName],
  )

  let closeOrOpenTranslate = (
    bool,
    fromButton = false,
    fromEffect = true,
    state = {},
  ) => {
    let newState = {
      ...dialogState,
      isSetHeight: bool && formFields.firstName && formFields.lastName,
      ...state,
    }
    if (fromButton) {
      newState.fromButton = fromButton

      if (!dialogState.isTranslated) {
        effects.apis.setTranslatedName({
          subscriberId: subscriber.id,
        })
      }
    }

    if (fromEffect) {
      newState.fromButton = true
      newState.isTranslated = true
    }

    setDialogState(newState)
  }

  useEffect(() => {
    setTimeout(() => {
      setDialogState({
        ...dialogState,
        isTranslated: true,
      })
    }, 100)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialogState.fromButton])

  let translateBtn = () => {
    if (isNameFilled) {
      let data = {
        firstName: formFields.firstName,
        lastName: formFields.lastName,
        middleName: formFields.middleName,
        sync: 1,
      }

      effects.apis
        .translateSubscriberFullName({
          subscriberId: subscriber.id,
          data,
        })
        .then((res) => {
          let { phoneticFirstName, phoneticMiddleName, phoneticLastName } = res

          setFormFields({
            ...formFields,
            phoneticFirstName,
            phoneticMiddleName,
            phoneticLastName,
          })
          disableOrAbleSaveBtn(false)
        })
    }
  }

  let handleChangeName = (e, fieldName) => {
    let value = e.target.value.trim()
    let obj = {
      ...formFields,
      [fieldName]: value,
    }

    let fullNameFields = ['firstName', 'lastName', 'middleName']
    if (fullNameFields.includes(fieldName)) {
      obj.isFullNameChanged = true
      isRendered = true
    }

    if ('middleName' === fieldName && value === '') {
      obj.phoneticMiddleName = ''
      obj.isFullNameChanged = false
      isRendered = false
    }

    setFormFields(obj)
  }

  useEffect(
    function () {
      let regExp = /[^\u0000-\u007f]/
      let isOpen = false
      let extraStateObj = {}

      if (
        formFields.isFullNameChanged &&
        regExp.test(
          `${formFields.firstName}${formFields.middleName}${formFields.lastName}`,
        )
      ) {
        isOpen = true
      } else if (
        (!formFields.phoneticFirstName || !formFields.phoneticLastName) &&
        regExp.test(
          `${formFields.firstName}${formFields.middleName}${formFields.lastName}`,
        )
      ) {
        isOpen = true
      }

      if (isFirstTimeRendered) {
        extraStateObj.isDisabledBtn = false
      }

      setTimeout(function () {
        closeOrOpenTranslate(isOpen, false, isRendered, extraStateObj)
      }, 2000)
      isFirstTimeRendered = true
    },
    [
      formFields.firstName,
      formFields.middleName,
      formFields.lastName,
      formFields.phoneticFirstName,
      formFields.phoneticLastName,
      formFields.isFullNameChanged,
    ],
  )

  let heightClass = dialogState.isTranslated
    ? styleClass.formTranslateSecondRowActive
    : styleClass.formTranslateRowActive
  const passportExpiresAtMaxDate = moment(new Date()).add(10, 'years') //it is arbitrary date

  function validatePrimaryContact(values) {
    return isHideContacts
      ? true
      : hasApp ||
          !R.isEmpty(values.fullPhoneNumber) ||
          !R.isEmpty(values.automatedCallFullPhoneNumber) ||
          !R.isEmpty(values.email)
  }

  const preferedContactRef = useRef(null)

  const channelsLable = (channels) => {
    switch (channels) {
      case CHANNEL_EMAIL:
        return 'crm.form.receiveMethods.email'
      case CHANNEL_SMS:
        return 'crm.form.receiveMethods.sms'
      case CHANNEL_CALL:
        return 'crm.form.receiveMethods.automatedCall'
      default:
        break
    }
  }

  function preferContactSelectDisplay(item) {
    switch (item.contactType) {
      case CONTACT_TYPE_APP:
        return formatMessage(
          {
            id: 'crm.form.receiveMethods.app',
          },
          {
            appName,
          },
        )
      case CONTACT_TYPE_CRM:
        return formatMessage(
          {
            id: channelsLable(item.channel),
          },
          {
            contact: item.contact,
            prefix: formatMessage({
              id: 'crm.header.label',
            }),
          },
        )
      case CONTACT_TYPE_OTHET:
        return formatMessage(
          {
            id: channelsLable(item.channel),
          },
          {
            contact: item.contact,
            prefix: formatMessage({
              id: 'label.other',
            }),
          },
        )
      case CONTACT_TYPE_REGISTERED:
        return formatMessage(
          {
            id: channelsLable(item.channel),
          },
          {
            contact: isHideContacts ? textLabelResticted() : item.contact,
            prefix: formatMessage({
              id: 'notification.channel.registered',
            }),
          },
        )
      default:
        return ''
    }
  }

  const handleValidatePrefer = useCallback(
    (value) => {
      const isValidationPrefer = R.compose(R.find(R.propEq('id', value)))(
        preferSelector,
      )
      setIsInvalidPrefer(isValidationPrefer.isBadContact)
    },
    [preferSelector],
  )

  const handleValidatePhoneNumber = useCallback((value, key) => {
    if (!value) return
    const isValue = !R.isNil(value) && !R.isEmpty(value)
    if (isValue && validatePhoneNumber(null, value)) {
      effects.apis
        .phoneValidation({
          phoneNumber: value,
        })
        .then((res) => {
          setIsInvalidPhone(false)
          handlePhoneNumber(value, key, false)
        })
        .catch((err) => {
          setIsInvalidPhone(true)
          handlePhoneNumber(value, key, true)
        })
    }
    setIsInvalidPhone(false)
  }, [])

  const updateEmailChannel = (value) => {
    if (isValidEmail(value)) {
      setFormFields({
        ...formFields,
        email: value,
      })

      const emialCrmInSelector = R.find((item) => {
        return (
          item.contactType === CONTACT_TYPE_CRM &&
          item.channel === CHANNEL_EMAIL
        )
      }, preferSelector)

      const emailDuplicate = R.find((item) => {
        return (
          item.contactType === CONTACT_TYPE_CRM &&
          item.channel === CHANNEL_EMAIL &&
          item.contact === value
        )
      }, subscriber.receiveMethods)

      if (R.isNil(emialCrmInSelector)) {
        setPreferSelector([
          ...preferSelector,
          R.isNil(emailDuplicate)
            ? {
                id: 'emailCrm',
                contact: value,
                channel: CHANNEL_EMAIL,
                contactType: CONTACT_TYPE_CRM,
              }
            : emailDuplicate,
        ])
      } else {
        if (emialCrmInSelector.contact !== value) {
          setPreferSelector(
            R.map((item) => {
              if (
                item.contactType === CONTACT_TYPE_CRM &&
                R.equals(item.channel, CHANNEL_EMAIL)
              ) {
                item.contact = value
              }
              return item
            }, preferSelector),
          )
        }
      }
    } else {
      setFormFields({
        ...formFields,
        email: null,
      })

      const isSelectedEmailCrm = R.compose(
        R.not,
        R.isNil,
        R.find((item) => {
          return (
            preferedContact === item.id &&
            item.contactType === CONTACT_TYPE_CRM &&
            item.channel === CHANNEL_EMAIL
          )
        }),
      )(preferSelector)

      if (isSelectedEmailCrm) {
        setPreferedContact('')
      }

      setPreferSelector(
        R.filter((item) => {
          return R.not(
            item.contactType === CONTACT_TYPE_CRM &&
              item.channel === CHANNEL_EMAIL,
          )
        }, preferSelector),
      )
    }
  }

  useEffect(() => {
    handleValidatePrefer(preferedContact)
  }, [crmFields.fullPhoneNumber, crmFields.automatedCallFullPhoneNumber])

  useEffect(() => {
    handleValidatePhoneNumber(crmFields.fullPhoneNumber, 'fullPhoneNumber')
    updateEmailChannel(crmFields.email)
    handlePhoneNumber(
      crmFields.automatedCallFullPhoneNumber,
      'automatedCallFullPhoneNumber',
      false,
    )
  }, [])

  const contactRef = useRef(null)
  useEffect(() => {
    isQuickAction &&
      setTimeout(() => {
        if (
          R.compose(
            R.not,
            R.anyPass([R.isNil, R.isEmpty]),
            R.prop('current'),
          )(contactRef)
        )
          contactRef.current.scrollIntoView({ behavior: 'smooth' })
      }, 500)
  }, [isQuickAction])

  return (
    <>
      <Dialog
        maxWidth="md"
        fullWidth={true}
        className={styleClass.dialogWrapper}
        open={true}
      >
        <Formsy
          className={styleClass.editForm}
          onValidSubmit={handleEditDetails}
          onChange={handleFormChange}
          onValid={() => {
            handleValidForm(true)
          }}
          onInvalid={() => {
            handleValidForm(false)
          }}
        >
          <DialogTitle
            disableTypography={true}
            className={styleClass.titleSection}
          >
            <div className={styleClass.titleSectionWrapper}>
              <div className={styleClass.titleSectionLeftSide}>
                <div className={styleClass.sectionTitle}>
                  {dialogState.fullName}
                </div>

                {isHideGroup && (
                  <GroupSelectCrm
                    selectedTags={crmFields.tags}
                    onTagsChange={handleTagsChange}
                    wrapperClass={styleClass.sectionTitleGroup}
                  />
                )}
                <div className={styleClass.subscriberDetailsStatus}>
                  <StatusChips
                    isShadow={true}
                    status={subscriber.lastInvitationStatus}
                    isShowTooltip={true}
                  />
                </div>
              </div>
              <div className={styleClass.titleSectionRightSide}>
                <CloseIcon onClick={openOrCloseEditDetailsDialog} />
              </div>
            </div>
          </DialogTitle>

          <DialogContent className={styleClass.contentSection}>
            <div className={styleClass.contentSectionWrapper}>
              {/*// First Name, Middle Name, Last Name*/}
              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon}>{avatarWrapper}</div>

                <div className={styleClass.formRowInputs}>
                  <div
                    className={clsx(
                      styleClass.formRowItemOne,
                      styleClass.formRowLeftItem,
                    )}
                  >
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.firstName"
                      placeholderId="crm.form.firstName"
                      variant="standard"
                      fullWidth
                      name="firstName"
                      onChange={(e) => handleChangeName(e, 'firstName')}
                      value={formFields.firstName}
                      getErrorMessage={() => {
                        return dialogState.errors['firstName'] && 'Invalid Data'
                      }}
                      maxLength={MAX_LENGTH}
                      isDisplayMaxLengthText={false}
                    />
                  </div>

                  <div className={styleClass.formRowItemOne}>
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.middleName"
                      placeholderId="crm.form.middleName"
                      variant="standard"
                      fullWidth
                      name="middleName"
                      onChange={(e) => handleChangeName(e, 'middleName')}
                      value={formFields.middleName}
                    />
                  </div>
                </div>
              </div>

              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon}></div>
                <div className={styleClass.formRowInputs}>
                  <div className={styleClass.formRowItemTwo}>
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="lastName.label"
                      placeholderId="lastName.label"
                      variant="standard"
                      fullWidth
                      name="lastName"
                      onChange={(e) => handleChangeName(e, 'lastName')}
                      value={formFields.lastName}
                      getErrorMessage={() => {
                        return dialogState.errors['lastName'] && 'Invalid Data'
                      }}
                      maxLength={MAX_LENGTH}
                      isDisplayMaxLengthText={false}
                    />
                  </div>
                </div>
              </div>

              <div
                className={clsx(
                  styleClass.formTranslateRow,
                  isNameFilled && dialogState.isSetHeight ? heightClass : '',
                )}
              >
                <div className={styleClass.formRowIcon} />
                <div className={styleClass.formTranslateWrapper}>
                  <div>
                    {dialogState.isTranslated ? (
                      <>
                        <FormattedMessage
                          id="subscriber.translateBox"
                          values={{
                            span: (text) => <span>{text}</span>,
                            b: (text) => (
                              <span
                                className={clsx(styleClass.formTranslateBtn)}
                                onClick={translateBtn}
                              >
                                {text}
                              </span>
                            ),
                            i: (text) => <span>{text}</span>,
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <FormattedMessage
                          id="subscriber.translateBox2"
                          values={{
                            span: (text) => <span>{text}</span>,
                            b: (text) => (
                              <span
                                className={clsx(styleClass.formTranslateBtn)}
                                onClick={translateBtn}
                              >
                                {text}
                              </span>
                            ),
                          }}
                        />
                      </>
                    )}
                  </div>

                  <CloseIcon
                    className={styleClass.formCloseTranslate}
                    onClick={() => closeOrOpenTranslate(false, true)}
                  />
                </div>
              </div>

              {/*// Phonetic first name, Phonetic middle name, Phonetic last name*/}
              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon} />

                <div className={styleClass.formRowInputs}>
                  <div
                    className={clsx(
                      styleClass.formRowItemOne,
                      styleClass.formRowLeftItem,
                    )}
                  >
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.phoneticFirstName"
                      placeholderId="crm.form.phoneticFirstName"
                      variant="standard"
                      fullWidth
                      name="phoneticFirstName"
                      onChange={(e) => handleChangeName(e, 'phoneticFirstName')}
                      value={formFields.phoneticFirstName}
                    />
                  </div>

                  <div className={styleClass.formRowItemOne}>
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.phoneticMiddleName"
                      placeholderId="crm.form.phoneticMiddleName"
                      variant="standard"
                      fullWidth
                      name="phoneticMiddleName"
                      onChange={(e) =>
                        handleChangeName(e, 'phoneticMiddleName')
                      }
                      value={formFields.phoneticMiddleName}
                    />
                  </div>
                </div>
              </div>

              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon}></div>
                <div className={styleClass.formRowInputs}>
                  <div className={styleClass.formRowItemTwo}>
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.phoneticLastName"
                      placeholderId="crm.form.phoneticLastName"
                      variant="standard"
                      fullWidth
                      name="phoneticLastName"
                      onChange={(e) => handleChangeName(e, 'phoneticLastName')}
                      value={formFields.phoneticLastName}
                    />
                  </div>
                </div>
              </div>

              {/*// Prefix, Suffix*/}
              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon} />

                <div className={styleClass.formRowInputs}>
                  <div
                    className={clsx(
                      styleClass.formRowItemOne,
                      styleClass.formRowLeftItem,
                    )}
                  >
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.prefix"
                      placeholderId="crm.form.prefix"
                      variant="standard"
                      fullWidth
                      name="prefix"
                      value={crmFields.prefix}
                    />
                  </div>

                  <div className={styleClass.formRowItemOne}>
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.suffix"
                      placeholderId="crm.form.suffix"
                      variant="standard"
                      fullWidth
                      name="suffix"
                      value={crmFields.suffix}
                    />
                  </div>
                </div>
              </div>

              {/*// Formal title, Nickname*/}
              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon} />

                <div className={styleClass.formRowInputs}>
                  <div
                    className={clsx(
                      styleClass.formRowItemOne,
                      styleClass.formRowLeftItem,
                    )}
                  >
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.formalTitle"
                      placeholderId="crm.form.formalTitle"
                      variant="standard"
                      fullWidth
                      name="formalTitle"
                      value={crmFields.formalTitle}
                    />
                  </div>

                  <div className={styleClass.formRowItemOne}>
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.nickname"
                      placeholderId="crm.form.nickname"
                      variant="standard"
                      fullWidth
                      name="nickname"
                      value={crmFields.nickname}
                    />
                  </div>
                </div>
              </div>

              {/*// Date of birth, Place of birth */}
              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon} />

                <div className={styleClass.formRowInputs}>
                  <div
                    className={clsx(
                      styleClass.formRowItemOne,
                      styleClass.formRowLeftItem,
                    )}
                  >
                    <MaterialUIPickers
                      TextFieldComponent={TextFieldDateComponent}
                      format={'MMMM d, yyyy'}
                      value={formFields.dateOfBirth}
                      handleDateChange={(date, dateWithFormat) => {
                        setFormFields({
                          ...formFields,
                          dateOfBirth: dateWithFormat,
                        })
                        disableOrAbleSaveBtn()
                      }}
                      inputVariant="standard"
                      label={formatMessage({
                        id: 'crm.form.dateOfBirth',
                      })}
                      className={styleClass.datePicker}
                    />
                  </div>

                  <div className={styleClass.formRowItemOne}>
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.placeOfBirth"
                      placeholderId="crm.form.placeOfBirth"
                      variant="standard"
                      fullWidth
                      name="placeOfBirth"
                      value={crmFields.placeOfBirth}
                    />
                  </div>
                </div>
              </div>

              {/*// Gender, Nationality*/}
              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon} />

                <div className={styleClass.formRowInputs}>
                  <div
                    className={clsx(
                      styleClass.formRowItemOne,
                      styleClass.formRowLeftItem,
                    )}
                  >
                    <GenderList
                      name="gender"
                      label="crm.form.gender"
                      value={crmFields.gender}
                    />
                  </div>

                  <div className={styleClass.formRowItemOne}>
                    <NationalityList
                      label="crm.form.nationality"
                      name="nationality"
                      value={crmFields.nationality}
                      formFields={formFields}
                      setFormFields={setFormFields}
                    />
                  </div>
                </div>
              </div>

              {/*// Unique ID*/}
              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon}></div>
                <div className={styleClass.formRowInputs}>
                  <div className={styleClass.formRowItemTwo}>
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="subscriber.label.uniqueId"
                      placeholderId="subscriber.label.uniqueId"
                      variant="standard"
                      fullWidth
                      name="uniqueId"
                      value={crmFields.uniqueId}
                      getErrorMessage={() => {
                        return dialogState.errors['uniqueId']
                      }}
                    />
                  </div>
                </div>
              </div>

              {/*// Care Check Id*/}
              {isDisplayCareCheck && (
                <div className={styleClass.formRow}>
                  <div className={styleClass.formRowIcon} />
                  <div className={styleClass.formRowInputs}>
                    <div className={styleClass.formRowItemTwo}>
                      <TextInput
                        margin="dense"
                        containerClassName="MuiFormControl-fullWidth"
                        labelId="crm.form.careCheckId"
                        placeholderId="crm.form.careCheckId"
                        variant="standard"
                        fullWidth
                        name="carecheckId"
                        value={crmFields.originalCareCheckId}
                        getErrorMessage={() => {
                          return dialogState.errors['carechekId']
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/*// Passport ID, Country code for passport?*/}
              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon} />

                <div className={styleClass.formRowInputs}>
                  <div
                    className={clsx(
                      styleClass.formRowItemOne,
                      styleClass.formRowLeftItem,
                    )}
                  >
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId="crm.form.passportId"
                      placeholderId="crm.form.passportId"
                      variant="standard"
                      fullWidth
                      name="passportId"
                      value={crmFields.passportId}
                    />
                  </div>

                  <div className={styleClass.formRowItemOne}>
                    <CountryList
                      label="crm.form.passportCountryCode"
                      name="passportCountryCode"
                      value={crmFields.passportCountryCode}
                      formFields={formFields}
                      setFormFields={setFormFields}
                      propOfCountryCode={'physicalCountryCode'}
                      propOfRegionType={'physicalRegionType'}
                      propOfCountryId={'physicalCountryId'}
                      showPassportCode={true}
                    />
                  </div>
                </div>
              </div>

              {/*// Passport expiration date, Is $FIRSTNAME contactable?*/}
              <div className={styleClass.formRow}>
                <div className={styleClass.formRowIcon} />

                <div className={styleClass.formRowInputs}>
                  <div
                    className={clsx(
                      styleClass.formRowItemOne,
                      styleClass.formRowLeftItem,
                    )}
                  >
                    <MaterialUIPickers
                      TextFieldComponent={TextFieldDateComponent}
                      format={'MMMM d, yyyy'}
                      value={formFields.passportExpiresAt}
                      handleDateChange={(date, dateWithFormat) => {
                        setFormFields({
                          ...formFields,
                          passportExpiresAt: dateWithFormat,
                        })
                        disableOrAbleSaveBtn()
                      }}
                      inputVariant="standard"
                      label={formatMessage({
                        id: 'crm.form.passportExpiresAt',
                      })}
                      className={styleClass.datePicker}
                      passportExpiresAtMaxDate={passportExpiresAtMaxDate}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: 'block',
                  marginBottom: 30,
                }}
                ref={contactRef}
              >
                <div
                  className={clsx(
                    styleClass.groupRowFirst,
                    styleClass.groupRow,
                  )}
                >
                  <div className={styleClass.groupRowIcon}>
                    <PersonOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRowTitle}>
                    {formatMessage({
                      id: 'crm.form.contactInformation',
                    })}
                    <CustomContactForm
                      label="Method"
                      saveCustomLabel={saveCustomLabel}
                    />
                  </div>
                </div>

                <div className={styleClass.formRow}>
                  <div className="w-full flex justify-between ml-80">
                    <SelectFormsy
                      ref={preferedContactRef}
                      name="preferedContact"
                      id="preferedContact"
                      value={preferedContact}
                      className="w-full mr-5 self-end"
                      classes={{ select: 'h-21' }}
                      label={formatMessage(
                        {
                          id: 'crm.form.notificationMethod',
                        },
                        { name: crmFields.firstName },
                      )}
                      disabled={!isSubscribed}
                      input={<Input />}
                      onChange={(event) => {
                        setPreferedContact(event.target.value)
                        handleValidatePrefer(event.target.value)
                      }}
                      validations={{
                        validateEmpty: (values, value) =>
                          R.compose(
                            R.not,
                            R.anyPass([R.isNil, R.isEmpty]),
                          )(value),
                      }}
                      validationErrors={{
                        validateEmpty: formatMessage({
                          id: 'error.form.required',
                        }),
                      }}
                    >
                      {R.isEmpty(preferSelector) ? (
                        <MenuItem value="" disabled>
                          <ListItemText
                            primary={formatMessage({
                              id: 'crm.form.receiveMethods.option.empty',
                            })}
                          />
                        </MenuItem>
                      ) : (
                        R.map((item) => {
                          return (
                            <MenuItem
                              key={`channelId-${item.id}`}
                              value={item.id}
                            >
                              <>
                                <ListItemText
                                  className="flex justify-between"
                                  primary={preferContactSelectDisplay(item)}
                                  secondary={
                                    item.isBadContact ? (
                                      <img
                                        width={20}
                                        height={20}
                                        src={Assets.badcontactIcon}
                                        alt="bad contact"
                                      />
                                    ) : null
                                  }
                                />
                              </>
                            </MenuItem>
                          )
                        })(preferSelector)
                      )}
                    </SelectFormsy>

                    <StatefulSelector
                      name="preferLanguage"
                      label={formatMessage({
                        id: 'preferred.language.label',
                      })}
                      variant="standard"
                      initialItemId={crmFields.preferLanguage}
                      fetcher={getAllLanguage}
                      className="ml-5 self-end"
                      disabled={R.isNil(subscriber.language) && isUnsubscribed}
                      LoadingComp={
                        <ProgressWithText
                          label={
                            <FormattedMessage id="languageSelector.state.loading" />
                          }
                          isDisable
                        />
                      }
                      ErrorComp={() => (
                        <FormattedMessage id="languageSelector.state.error" />
                      )}
                      EmptyComp={
                        <FormattedMessage id="languageSelector.state.empty" />
                      }
                      ValidComp={(language) => (
                        <LanguageRenderItem language={language} />
                      )}
                      fullWidth
                      validations={{
                        validateRequired: validateRequired,
                      }}
                      validationErrors={{
                        validateRequired: formatMessage({
                          id: 'error.form.required',
                        }),
                      }}
                      InputProps={{
                        'data-testid': 'userDisplayAuthorLanguage',
                      }}
                    />

                    {isInvalidPrefer ? (
                      <div className="text-mustard pt-2 text-xs">
                        {formatMessage({
                          id: 'error.form.badContact',
                        })}
                      </div>
                    ) : null}
                  </div>
                </div>

                {mes_248_remove_additional_phone_fields ? (
                  <>
                    <div className="w-full flex">
                      <div className={styleClass.formRowIcon} />
                      <div className={styleClass.contactFields}>
                        <div className="w-full md:w-11/12 mb-10">
                          <TextInput
                            margin="dense"
                            containerClassName="MuiFormControl-fullWidth"
                            labelId="crm.form.email"
                            placeholderId="crm.form.email"
                            variant="outlined"
                            fullWidth
                            name="email"
                            value={crmFields.email}
                            validations={{
                              isEmailValid: (values, value) =>
                                R.isEmpty(value) ? true : isValidEmail(value),
                              isPrimaryContactValid: validatePrimaryContact,
                            }}
                            validationErrors={{
                              isEmailValid: formatMessage({
                                id: 'memberForm.emailInvalid',
                              }),
                              isPrimaryContactValid: formatMessage({
                                id: 'crm.form.primaryContact.empty',
                              }),
                            }}
                            onChange={(ev) => {
                              ev.persist()
                              const debounce = _.debounce(
                                () => updateEmailChannel(ev.target.value),
                                1000,
                              )
                              debounce()
                            }}
                          />
                        </div>
                        {crmCustomfields[CONTACT] !== undefined &&
                          crmCustomfields[CONTACT].filter(
                            R.propEq('fieldType', TEXT),
                          ).map((emailfield, index) => {
                            return (
                              // to do Missing "key" prop for element in array
                              <div className="mb-10">
                                <CustomFieldForm
                                  key={index}
                                  index={index}
                                  customField={emailfield}
                                  updateCustomFieldsContentData={
                                    updateCustomFieldsContentData
                                  }
                                  variant="outlined"
                                  parentMethod={CONTACT}
                                  deleteCustomLabel={() =>
                                    handleCustomfields(emailfield.id, CONTACT)
                                  }
                                  isLocal={false}
                                  validations={{
                                    isEmailValid: (values, value) =>
                                      R.isEmpty(value)
                                        ? true
                                        : isValidEmail(value),
                                  }}
                                  validationErrors={{
                                    isEmailValid: formatMessage({
                                      id: 'memberForm.emailInvalid',
                                    }),
                                  }}
                                  confirmDelete={false}
                                />
                              </div>
                            )
                          })}
                        {customLabels &&
                          customLabels[CONTACT].filter(
                            R.propEq('labelType', 'crm.custom.field.email'),
                          ).map((emailData, index) => {
                            return (
                              // to do Missing "key" prop for element in array
                              <div className="mb-10">
                                <CustomFieldForm
                                  key={index}
                                  index={index}
                                  customField={emailData}
                                  updateCustomFieldsContentData={
                                    updateCustomFieldsContentData
                                  }
                                  parentMethod={CONTACT}
                                  deleteCustomLabel={() =>
                                    deleteCustomLocalLabel(
                                      emailData.localId,
                                      CONTACT,
                                    )
                                  }
                                  isLocal={true}
                                  validations={{
                                    isEmailValid: (values, value) =>
                                      R.isEmpty(value)
                                        ? true
                                        : isValidEmail(value),
                                  }}
                                  validationErrors={{
                                    isEmailValid: formatMessage({
                                      id: 'memberForm.emailInvalid',
                                    }),
                                  }}
                                  confirmDelete={false}
                                />
                              </div>
                            )
                          })}
                      </div>
                    </div>

                    <div className={styleClass.formRow}>
                      <div className="w-full grid grid-cols-2 gap-10 ml-80">
                        <div className="mr-5">
                          <PhoneNumberInputFormsy
                            ref={phoneNumberRef}
                            className="w-full"
                            variantType="standard"
                            autoComplete="new-password"
                            enableSearchField
                            disableSearchIcon
                            disableAreaCodes={true}
                            label={formatMessage({
                              id: 'crm.form.primaryPhone',
                            })}
                            defaultCountry={'us'}
                            name="fullPhoneNumber"
                            value={crmFields.fullPhoneNumber || ''}
                            onChange={(number) => {
                              handleValidatePhoneNumber(
                                number,
                                'fullPhoneNumber',
                              )
                            }}
                            validations={{
                              isPhoneNumber: (values, value) =>
                                R.isNil(value)
                                  ? true
                                  : validatePhoneNumber(null, value),
                              isPrimaryContactValid: validatePrimaryContact,
                            }}
                            validationErrors={{
                              isPhoneNumber: formatMessage({
                                id: 'registerForm.phoneNumberInvalid',
                              }),
                              isPrimaryContactValid: formatMessage({
                                id: 'crm.form.primaryContact.empty',
                              }),
                            }}
                          />
                          {isInvalidPhone ? (
                            <div className="text-mustard pt-2 text-xs">
                              {formatMessage({
                                id: 'error.form.badContact',
                              })}
                            </div>
                          ) : null}
                        </div>

                        {place.enabledAutomatedCall ||
                        preferSelector.some(
                          (ch) => ch.channel === CHANNEL_CALL,
                        ) ? (
                          <div className="mr-5">
                            <PhoneNumberInputFormsy
                              className="w-full"
                              variantType="standard"
                              autoComplete="new-password"
                              label={formatMessage({
                                id: 'message.credit.alert.dialog.automateCall',
                              })}
                              disabled={!place.enabledAutomatedCall}
                              defaultCountry={'us'}
                              onlyCountries={['us']}
                              name="automatedCallFullPhoneNumber"
                              value={crmFields.automatedCallFullPhoneNumber}
                              onChange={(number) => {
                                handleValidatePhoneNumber(
                                  number,
                                  'automatedCallFullPhoneNumber',
                                )
                              }}
                              validations={{
                                isPhoneNumber: (values, value) =>
                                  R.isNil(value)
                                    ? true
                                    : validatePhoneNumber(null, value),
                                isPrimaryContactValid: validatePrimaryContact,
                              }}
                              validationErrors={{
                                isPhoneNumber: formatMessage({
                                  id: 'registerForm.phoneNumberInvalid',
                                }),
                                isPrimaryContactValid: formatMessage({
                                  id: 'crm.form.primaryContact.empty',
                                }),
                              }}
                            />
                            {isInvalidPhone ? (
                              <div className="text-mustard pt-2 text-xs">
                                {formatMessage({
                                  id: 'error.form.badContact',
                                })}
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                        <div>
                          {crmCustomfields[CONTACT] !== undefined &&
                            crmCustomfields[CONTACT].filter(
                              R.propEq('fieldType', PHONE_NUMBER),
                            ).map((phoneFieldData, index) => {
                              return (
                                <div key={index} className="flex mb-10">
                                  <PhoneNumberInputFormsy
                                    className="w-full"
                                    variantType="standard"
                                    autoComplete="new-password"
                                    enableSearchField
                                    disableSearchIcon
                                    disableAreaCodes={true}
                                    label={phoneFieldData.label}
                                    defaultCountry={'us'}
                                    name={phoneFieldData.label}
                                    value={phoneFieldData.content}
                                    onChange={(number) => {
                                      updateCustomFieldsContentData({
                                        value: number,
                                        method: CONTACT,
                                        id: phoneFieldData.id,
                                        isLocal: false,
                                      })
                                    }}
                                    validations={{
                                      isPhoneNumber: (values, value) => {
                                        return (
                                          value === '+' ||
                                          value === '+1' ||
                                          validatePhoneNumber(values, value)
                                        )
                                      },
                                    }}
                                    validationErrors={{
                                      isPhoneNumber: formatMessage({
                                        id: 'registerForm.phoneNumberInvalid',
                                      }),
                                    }}
                                  />
                                  <CloseIcon
                                    onClick={() =>
                                      handleCustomfields(
                                        phoneFieldData.id,
                                        CONTACT,
                                      )
                                    }
                                    fontSize="small"
                                    className={styleClass.customLabelCloseIcon}
                                  />
                                </div>
                              )
                            })}

                          {customLabels &&
                            customLabels[CONTACT].filter(
                              R.propEq('labelType', 'phone.label'),
                            ).map((phoneData, index) => {
                              return (
                                <div key={index} className="flex mb-10">
                                  <PhoneNumberInputFormsy
                                    variantType="standard"
                                    autoComplete="new-password"
                                    enableSearchField
                                    disableSearchIcon
                                    disableAreaCodes={true}
                                    label={phoneData.label}
                                    defaultCountry={'us'}
                                    name={phoneData.label}
                                    value={'+1'}
                                    onChange={(number) => {
                                      updateCustomFieldsContentData({
                                        value: number,
                                        method: CONTACT,
                                        id: phoneData.localId,
                                        isLocal: true,
                                      })
                                    }}
                                    validations={{
                                      isPhoneNumber: (values, value) => {
                                        return (
                                          value === '+' ||
                                          value === '+1' ||
                                          validatePhoneNumber(values, value)
                                        )
                                      },
                                    }}
                                    validationErrors={{
                                      isPhoneNumber: formatMessage({
                                        id: 'registerForm.phoneNumberInvalid',
                                      }),
                                    }}
                                  />
                                  <CloseIcon
                                    onClick={() =>
                                      deleteCustomLocalLabel(
                                        phoneData.localId,
                                        CONTACT,
                                      )
                                    }
                                    fontSize="small"
                                    className={styleClass.customLabelCloseIcon}
                                  />
                                </div>
                              )
                            })}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {/*// Email Address, Secondary email address*/}
                    <div className={styleClass.formRow}>
                      <div className={styleClass.formRowIcon} />
                      <div className={styleClass.formRowInputs}>
                        <div
                          className={clsx(
                            styleClass.formRowItemOne,
                            styleClass.formRowLeftItem,
                          )}
                        >
                          <TextInput
                            margin="dense"
                            containerClassName="MuiFormControl-fullWidth"
                            labelId="crm.form.email"
                            placeholderId="crm.form.email"
                            variant="standard"
                            fullWidth
                            name="email"
                            value={crmFields.email}
                            validations={{
                              isEmailValid: (values, value) =>
                                R.isEmpty(value) ? true : isValidEmail(value),
                              isPrimaryContactValid: validatePrimaryContact,
                            }}
                            validationErrors={{
                              isEmailValid: formatMessage({
                                id: 'memberForm.emailInvalid',
                              }),
                              isPrimaryContactValid: formatMessage({
                                id: 'crm.form.primaryContact.empty',
                              }),
                            }}
                            onChange={(ev) => {
                              ev.persist()
                              const debounce = _.debounce(() => {
                                if (isValidEmail(ev.target.value)) {
                                  setFormFields({
                                    ...formFields,
                                    email: ev.target.value,
                                  })

                                  const emialCrmInSelector = R.find((item) => {
                                    return (
                                      item.contactType === CONTACT_TYPE_CRM &&
                                      item.channel === CHANNEL_EMAIL
                                    )
                                  }, preferSelector)

                                  const emailDuplicate = R.find((item) => {
                                    return (
                                      item.contactType === CONTACT_TYPE_CRM &&
                                      item.channel === CHANNEL_EMAIL &&
                                      item.contact === ev.target.value
                                    )
                                  }, subscriber.receiveMethods)

                                  if (R.isNil(emialCrmInSelector)) {
                                    setPreferSelector([
                                      ...preferSelector,
                                      R.isNil(emailDuplicate)
                                        ? {
                                            id: 'emailCrm',
                                            contact: ev.target.value,
                                            channel: CHANNEL_EMAIL,
                                            contactType: CONTACT_TYPE_CRM,
                                          }
                                        : emailDuplicate,
                                    ])
                                  } else {
                                    if (
                                      emialCrmInSelector.contact !==
                                      ev.target.value
                                    ) {
                                      setPreferSelector(
                                        R.map((item) => {
                                          if (
                                            item.contactType ===
                                              CONTACT_TYPE_CRM &&
                                            R.equals(
                                              item.channel,
                                              CHANNEL_EMAIL,
                                            )
                                          ) {
                                            item.contact = ev.target.value
                                          }
                                          return item
                                        }, preferSelector),
                                      )
                                    }
                                  }
                                } else {
                                  setFormFields({
                                    ...formFields,
                                    email: null,
                                  })

                                  const isSelectedEmailCrm = R.compose(
                                    R.not,
                                    R.isNil,
                                    R.find((item) => {
                                      return (
                                        preferedContact === item.id &&
                                        item.contactType === CONTACT_TYPE_CRM &&
                                        item.channel === CHANNEL_EMAIL
                                      )
                                    }),
                                  )(preferSelector)

                                  if (isSelectedEmailCrm) {
                                    setPreferedContact('')
                                  }

                                  setPreferSelector(
                                    R.filter((item) => {
                                      return R.not(
                                        item.contactType === CONTACT_TYPE_CRM &&
                                          item.channel === CHANNEL_EMAIL,
                                      )
                                    }, preferSelector),
                                  )
                                }
                              }, 1000)
                              debounce()
                            }}
                          />
                        </div>
                        <div className={styleClass.formRowItemOne}>
                          <TextInput
                            margin="dense"
                            containerClassName="MuiFormControl-fullWidth"
                            labelId="crm.form.secondaryEmail"
                            placeholderId="crm.form.secondaryEmail"
                            variant="standard"
                            fullWidth
                            name="secondaryEmail"
                            value={crmFields.secondaryEmail}
                            validations={{
                              isEmailValid: (values, value) =>
                                R.isEmpty(value) ? true : isValidEmail(value),
                            }}
                            validationErrors={{
                              isEmailValid: formatMessage({
                                id: 'memberForm.emailInvalid',
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Email customFieldStyle */}
                    <div className={styleClass.customFieldStyle}>
                      {crmCustomfields[CONTACT] !== undefined &&
                        crmCustomfields[CONTACT].filter(
                          R.propEq('fieldType', TEXT),
                        ).map((emailfield, index) => {
                          return (
                            <CustomFieldForm
                              key={index}
                              index={index}
                              customField={emailfield}
                              updateCustomFieldsContentData={
                                updateCustomFieldsContentData
                              }
                              parentMethod={CONTACT}
                              deleteCustomLabel={() =>
                                handleDeleteCRMCustomfield(
                                  emailfield.id,
                                  CONTACT,
                                )
                              }
                              isLocal={false}
                              validations={{
                                isEmailValid: (values, value) =>
                                  R.isEmpty(value) ? true : isValidEmail(value),
                                isPrimaryContactValid: validatePrimaryContact,
                              }}
                              validationErrors={{
                                isEmailValid: formatMessage({
                                  id: 'memberForm.emailInvalid',
                                }),
                                isPrimaryContactValid: formatMessage({
                                  id: 'crm.form.primaryContact.empty',
                                }),
                              }}
                            />
                          )
                        })}
                      {customLabels &&
                        customLabels[CONTACT].filter(
                          R.propEq('labelType', 'crm.custom.field.email'),
                        ).map((emailData, index) => {
                          return (
                            <CustomFieldForm
                              key={index}
                              index={index}
                              customField={emailData}
                              updateCustomFieldsContentData={
                                updateCustomFieldsContentData
                              }
                              parentMethod={CONTACT}
                              deleteCustomLabel={() =>
                                deleteCustomLocalLabel(
                                  emailData.localId,
                                  CONTACT,
                                )
                              }
                              isLocal={true}
                              validations={{
                                isEmailValid: (values, value) =>
                                  R.isEmpty(value) ? true : isValidEmail(value),
                                isPrimaryContactValid: validatePrimaryContact,
                              }}
                              validationErrors={{
                                isEmailValid: formatMessage({
                                  id: 'memberForm.emailInvalid',
                                }),
                                isPrimaryContactValid: formatMessage({
                                  id: 'crm.form.primaryContact.empty',
                                }),
                              }}
                            />
                          )
                        })}
                    </div>

                    {/*// Primary phone, Other mobile number*/}
                    <div className={styleClass.formRow}>
                      <div className={styleClass.formRowIcon} />
                      <div className={styleClass.formRowInputs}>
                        <div
                          className={clsx(
                            styleClass.formRowItemOne,
                            styleClass.formRowLeftItem,
                          )}
                        >
                          <PhoneNumberInputFormsy
                            ref={phoneNumberRef}
                            className="w-full"
                            variantType="standard"
                            autoComplete="new-password"
                            enableSearchField
                            disableSearchIcon
                            disableAreaCodes={true}
                            label={formatMessage({
                              id: 'crm.form.primaryPhone',
                            })}
                            defaultCountry={'us'}
                            name="fullPhoneNumber"
                            value={crmFields.fullPhoneNumber || ''}
                            onChange={(number) => {
                              handlePhoneNumber(number, 'fullPhoneNumber')
                            }}
                            validations={{
                              isPhoneNumber: (values, value) =>
                                R.isNil(value)
                                  ? true
                                  : validatePhoneNumber(null, value),
                              isPrimaryContactValid: validatePrimaryContact,
                              validateBadContacts: (values, value) => {
                                return !R.and(
                                  R.equals(crmFields.fullPhoneNumber, value),
                                  R.compose(
                                    R.propEq('isBadContact', true),
                                    R.find(
                                      R.allPass([
                                        R.propEq('channel', CHANNEL_SMS),
                                        R.propEq(
                                          'contactType',
                                          CONTACT_TYPE_CRM,
                                        ),
                                        R.propEq('contact', value),
                                      ]),
                                    ),
                                  )(preferSelector),
                                )
                              },
                            }}
                            validationErrors={{
                              isPhoneNumber: formatMessage({
                                id: 'registerForm.phoneNumberInvalid',
                              }),
                              isPrimaryContactValid: formatMessage({
                                id: 'crm.form.primaryContact.empty',
                              }),
                              validateBadContacts: formatMessage({
                                id: 'error.form.badContact',
                              }),
                            }}
                          />
                        </div>

                        <div className={styleClass.formRowItemOne}>
                          <PhoneNumberInputFormsy
                            className="w-full"
                            variantType="standard"
                            autoComplete="new-password"
                            enableSearchField
                            disableSearchIcon
                            disableAreaCodes={true}
                            label={formatMessage({
                              id: 'crm.form.otherMobileNumber',
                            })}
                            defaultCountry={'us'}
                            name="fullOtherMobileNumber"
                            value={crmFields.fullOtherMobileNumber || '+1'}
                            onChange={(number) => {
                              handlePhoneNumber(number, 'fullOtherMobileNumber')
                            }}
                            validations={{
                              isPhoneNumber: (values, value) => {
                                return (
                                  value === '+' ||
                                  value === '+1' ||
                                  validatePhoneNumber(values, value)
                                )
                              },
                            }}
                            validationErrors={{
                              isPhoneNumber: formatMessage({
                                id: 'registerForm.phoneNumberInvalid',
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {/*// Other phone number, Office phone number*/}
                    <div className={styleClass.formRow}>
                      <div className={styleClass.formRowIcon} />
                      <div className={styleClass.formRowInputs}>
                        <div
                          className={clsx(
                            styleClass.formRowItemOne,
                            styleClass.formRowLeftItem,
                          )}
                        >
                          <PhoneNumberInputFormsy
                            className="w-full"
                            variantType="standard"
                            autoComplete="new-password"
                            enableSearchField
                            disableSearchIcon
                            disableAreaCodes={true}
                            label={formatMessage({
                              id: 'crm.form.otherPhoneNumber',
                            })}
                            defaultCountry={'us'}
                            name="fullOtherPhoneNumber"
                            value={crmFields.fullOtherPhoneNumber || '+1'}
                            onChange={(number) => {
                              handlePhoneNumber(number, 'fullOtherPhoneNumber')
                            }}
                            validations={{
                              isPhoneNumber: (values, value) => {
                                return (
                                  value === '+' ||
                                  value === '+1' ||
                                  validatePhoneNumber(values, value)
                                )
                              },
                            }}
                            validationErrors={{
                              isPhoneNumber: formatMessage({
                                id: 'registerForm.phoneNumberInvalid',
                              }),
                            }}
                          />
                        </div>

                        <div className={styleClass.formRowItemOne}>
                          <PhoneNumberInputFormsy
                            className="w-full"
                            variantType="standard"
                            autoComplete="new-password"
                            enableSearchField
                            disableSearchIcon
                            disableAreaCodes={true}
                            label={formatMessage({
                              id: 'crm.form.officePhoneNumber',
                            })}
                            defaultCountry={'us'}
                            name="fullOfficePhoneNumber"
                            value={crmFields.fullOfficePhoneNumber || '+1'}
                            onChange={(number) => {
                              handlePhoneNumber(number, 'fullOfficePhoneNumber')
                            }}
                            validations={{
                              isPhoneNumber: (values, value) => {
                                return (
                                  value === '+' ||
                                  value === '+1' ||
                                  validatePhoneNumber(values, value)
                                )
                              },
                            }}
                            validationErrors={{
                              isPhoneNumber: formatMessage({
                                id: 'registerForm.phoneNumberInvalid',
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {/*// Home phone number, Fax number*/}
                    <div className={styleClass.formRow}>
                      <div className={styleClass.formRowIcon} />
                      <div className={styleClass.formRowInputs}>
                        <div
                          className={clsx(
                            styleClass.formRowItemOne,
                            styleClass.formRowLeftItem,
                          )}
                        >
                          <PhoneNumberInputFormsy
                            className="w-full"
                            variantType="standard"
                            autoComplete="new-password"
                            enableSearchField
                            disableSearchIcon
                            disableAreaCodes={true}
                            label={formatMessage({
                              id: 'crm.form.homePhoneNumber',
                            })}
                            defaultCountry={'us'}
                            name="fullHomePhoneNumber"
                            value={crmFields.fullHomePhoneNumber || '+1'}
                            onChange={(number) => {
                              handlePhoneNumber(number, 'fullHomePhoneNumber')
                            }}
                            validations={{
                              isPhoneNumber: (values, value) => {
                                return (
                                  value === '+' ||
                                  value === '+1' ||
                                  validatePhoneNumber(values, value)
                                )
                              },
                            }}
                            validationErrors={{
                              isPhoneNumber: formatMessage({
                                id: 'registerForm.phoneNumberInvalid',
                              }),
                            }}
                          />
                        </div>

                        <div className={styleClass.formRowItemOne}>
                          <PhoneNumberInputFormsy
                            className="w-full"
                            variantType="standard"
                            autoComplete="new-password"
                            enableSearchField
                            disableSearchIcon
                            disableAreaCodes={true}
                            label={formatMessage({
                              id: 'crm.form.faxNumber',
                            })}
                            defaultCountry={'us'}
                            name="fullFaxNumber"
                            value={crmFields.fullFaxNumber || '+1'}
                            onChange={(number) => {
                              handlePhoneNumber(number, 'fullFaxNumber')
                            }}
                            validations={{
                              isPhoneNumber: (values, value) => {
                                return (
                                  value === '+' ||
                                  value === '+1' ||
                                  validatePhoneNumber(values, value)
                                )
                              },
                            }}
                            validationErrors={{
                              isPhoneNumber: formatMessage({
                                id: 'registerForm.phoneNumberInvalid',
                              }),
                            }}
                          />
                        </div>
                      </div>
                      <div className={styleClass.customContactStyle}></div>
                    </div>
                    {/* Number Phone customFieldStyle */}
                    <div className={styleClass.customFieldStyle}>
                      {crmCustomfields[CONTACT] !== undefined &&
                        crmCustomfields[CONTACT].filter(
                          R.propEq('fieldType', PHONE_NUMBER),
                        ).map((phoneFieldData, index) => {
                          return (
                            <div
                              key={index}
                              className={styleClass.customLabelWrapper}
                            >
                              <PhoneNumberInputFormsy
                                className="w-full"
                                variantType="standard"
                                autoComplete="new-password"
                                enableSearchField
                                disableSearchIcon
                                disableAreaCodes={true}
                                label={phoneFieldData.label}
                                defaultCountry={'us'}
                                name={phoneFieldData.label}
                                value={phoneFieldData.content}
                                onChange={(number) => {
                                  updateCustomFieldsContentData({
                                    value: number,
                                    method: CONTACT,
                                    id: phoneFieldData.id,
                                    isLocal: false,
                                  })
                                }}
                                validations={{
                                  isPhoneNumber: (values, value) => {
                                    return (
                                      value === '+' ||
                                      value === '+1' ||
                                      validatePhoneNumber(values, value)
                                    )
                                  },
                                }}
                                validationErrors={{
                                  isPhoneNumber: formatMessage({
                                    id: 'registerForm.phoneNumberInvalid',
                                  }),
                                }}
                              />
                              <CloseIcon
                                onClick={() =>
                                  setOpenDeleteCustomField(phoneFieldData.id)
                                }
                                fontSize="small"
                                className={styleClass.customLabelCloseIcon}
                              />
                              <ConfirmDeleteCustomFieldPopup
                                deleteCustomLabel={() =>
                                  handleDeleteCRMCustomfield(
                                    phoneFieldData.id,
                                    CONTACT,
                                  )
                                }
                                openDeleteCustomField={
                                  openDeleteCustomField === phoneFieldData.id
                                }
                                setOpenDeleteCustomField={
                                  setOpenDeleteCustomField
                                }
                              />
                            </div>
                          )
                        })}
                      {customLabels &&
                        customLabels[CONTACT].filter(
                          R.propEq('labelType', 'phone.label'),
                        ).map((phoneData, index) => {
                          return (
                            <div
                              key={index}
                              className={styleClass.customLabelWrapper}
                            >
                              <PhoneNumberInputFormsy
                                className="w-full"
                                variantType="standard"
                                autoComplete="new-password"
                                enableSearchField
                                disableSearchIcon
                                disableAreaCodes={true}
                                label={phoneData.label}
                                defaultCountry={'us'}
                                name={phoneData.label}
                                value={'+1'}
                                onChange={(number) => {
                                  updateCustomFieldsContentData({
                                    value: number,
                                    method: CONTACT,
                                    id: phoneData.localId,
                                    isLocal: true,
                                  })
                                }}
                                validations={{
                                  isPhoneNumber: (values, value) => {
                                    return (
                                      value === '+' ||
                                      value === '+1' ||
                                      validatePhoneNumber(values, value)
                                    )
                                  },
                                }}
                                validationErrors={{
                                  isPhoneNumber: formatMessage({
                                    id: 'registerForm.phoneNumberInvalid',
                                  }),
                                }}
                              />
                              <CloseIcon
                                onClick={() =>
                                  setOpenDeleteCustomField(phoneData.localId)
                                }
                                fontSize="small"
                                className={styleClass.customLabelCloseIcon}
                              />
                              <ConfirmDeleteCustomFieldPopup
                                deleteCustomLabel={() =>
                                  deleteCustomLocalLabel(
                                    phoneData.localId,
                                    CONTACT,
                                  )
                                }
                                openDeleteCustomField={
                                  openDeleteCustomField === phoneData.localId
                                }
                                setOpenDeleteCustomField={
                                  setOpenDeleteCustomField
                                }
                              />
                            </div>
                          )
                        })}
                    </div>
                  </>
                )}

                <div className={styleClass.formRow}>
                  <div className={styleClass.formRowIcon} />
                  <div className={styleClass.formRowInputs}>
                    <Tooltip
                      title={
                        <div className="text-14 leading-tight">
                          <FormattedMessage
                            id="crm.form.contactable.hint"
                            values={{
                              name: crmFields.firstName,
                            }}
                          />
                        </div>
                      }
                      placement="left-end"
                    >
                      <div className={styleClass.formRowItemOne}>
                        <SelectFormsy
                          className={clsx('w-full')}
                          name="contactable"
                          label={formatMessage({
                            id: 'crm.form.contactable',
                          })}
                          value={crmFields.contactable}
                          variant="standard"
                        >
                          <MenuItem value={0}>
                            <Typography>
                              <FormattedMessage id="action.no" />
                            </Typography>
                          </MenuItem>
                          <MenuItem value={1}>
                            <Typography>
                              <FormattedMessage id="action.yes" />
                            </Typography>
                          </MenuItem>
                        </SelectFormsy>
                      </div>
                    </Tooltip>
                  </div>
                </div>
                <div className={styleClass.groupRow}>
                  <div className={styleClass.groupRowIcon}>
                    <EditLocationOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRowTitle}>
                    {formatMessage({
                      id: 'crm.form.physicalAddress',
                    })}
                    <CustomAddressForm saveAddressData={saveCustomLabel} />
                  </div>
                </div>
                <AddressFields
                  crmFields={crmFields}
                  formFields={formFields}
                  setFormFields={setFormFields}
                  setCity={setCity}
                  countryData={{
                    countryDataLabel: 'crm.form.physicalCountry',
                    countryDataName: 'physicalCountryId',
                    countryDataValue: crmFields.physicalCountry['id'],
                    propOfCountryCode: 'physicalCountryCode',
                    propOfRegionType: 'physicalRegionType',
                    propOfCountryId: 'physicalCountryId',
                  }}
                  placesNameAutocompleteFormsyData={{
                    labelId: 'crm.form.physicalStreetAddress',
                    placeholderId: 'crm.form.physicalStreetAddress',
                    cityProperty: 'physicalCityName',
                    variant: 'standard',
                    name: 'physicalStreetAddress1',
                    value: crmFields.physicalStreetAddress1,
                    restriction: formFields.physicalCountryCode,
                  }}
                  address2={{
                    labelId: 'crm.form.physicalStreetAddressLine2',
                    placeholderId: 'crm.form.physicalStreetAddressLine2',
                    variant: 'standard',
                    name: 'physicalStreetAddress2',
                    value: crmFields.physicalStreetAddress2,
                  }}
                  physicalCityName={{
                    labelId: 'crm.form.physicalCityName',
                    placeholderId: 'crm.form.physicalCityName',
                    name: 'physicalCityName',
                    value: formFields.physicalCityName,
                  }}
                  physicalPostalCode={{
                    labelId: 'crm.form.physicalPostalCode',
                    placeholderId: 'crm.form.physicalPostalCode',
                    name: 'physicalPostalCode',
                    value: crmFields.physicalPostalCode,
                  }}
                  statesSwitchList={{
                    value: crmFields.physicalState['id'],
                    regionType: formFields.physicalRegionType,
                    countryId: formFields.physicalCountryId,
                    name: 'physicalStateId',
                  }}
                />
                {/* Get custom physical fields from backend */}
                {crmCustomfields[PHYSICAL_ADDRESS] !== undefined &&
                  crmCustomfields[PHYSICAL_ADDRESS].map(
                    (physicalAddressData) => (
                      <div key={physicalAddressData.id}>
                        <div className={styleClass.groupRow}>
                          <div className={styleClass.groupRowIcon}>
                            <EditLocationOutlinedIcon />
                          </div>
                          <div className={styleClass.groupRowTitle}>
                            {physicalAddressData.label}
                            <CloseIcon
                              onClick={() =>
                                setOpenDeleteCustomField(physicalAddressData.id)
                              }
                              fontSize="small"
                              className={styleClass.customLabelCloseIcon}
                            />
                            <ConfirmDeleteCustomFieldPopup
                              deleteCustomLabel={() =>
                                handleDeleteCRMCustomfield(
                                  physicalAddressData.id,
                                  PHYSICAL_ADDRESS,
                                )
                              }
                              openDeleteCustomField={
                                openDeleteCustomField === physicalAddressData.id
                              }
                              setOpenDeleteCustomField={
                                setOpenDeleteCustomField
                              }
                            />
                          </div>
                        </div>
                        <AddressFields
                          formFields={physicalAddressData}
                          setFormFields={(updatedDate) => {
                            updateCustomAddressFieldData({
                              currentValue: updatedDate.physicalCountryId,
                              addressDataId: physicalAddressData.id,
                              labelName: 'Country',
                              labelMethod: PHYSICAL_ADDRESS,
                              isLocal: false,
                              countryCode: updatedDate.physicalCountryCode,
                              countryId: updatedDate.physicalCountryId,
                              regionType: updatedDate.physicalRegionType,
                            })
                          }}
                          setCity={setCustomCity}
                          countryData={{
                            countryDataLabel: 'crm.form.physicalCountry',
                            countryDataName:
                              physicalAddressData.subFields[0].label,
                            countryDataValue:
                              physicalAddressData.subFields[0].content,
                            propOfCountryCode: 'physicalCountryCode',
                            propOfRegionType: 'physicalRegionType',
                            propOfCountryId: 'physicalCountryId',
                          }}
                          placesNameAutocompleteFormsyData={{
                            labelId: 'crm.form.physicalStreetAddress',
                            placeholderId: 'crm.form.physicalStreetAddress',
                            cityProperty: 'physicalCityName',
                            variant: 'standard',
                            name: `${physicalAddressData.id}_physicalStreetAddress1`,
                            value: physicalAddressData.subFields[1].content,
                            restriction:
                              physicalAddressData.customAttributes
                                .physicalCountryCode,
                          }}
                          address2={{
                            labelId: 'crm.form.physicalStreetAddressLine2',
                            placeholderId:
                              'crm.form.physicalStreetAddressLine2',
                            variant: 'standard',
                            name: `${physicalAddressData.id}_physicalStreetAddress2`,
                            value: physicalAddressData.subFields[2].content,
                          }}
                          physicalCityName={{
                            labelId: 'crm.form.physicalCityName',
                            placeholderId: 'crm.form.physicalCityName',
                            name: `${physicalAddressData.id}_physicalCityName`,
                            value: physicalAddressData.subFields[3].content,
                          }}
                          physicalPostalCode={{
                            labelId: 'crm.form.physicalPostalCode',
                            placeholderId: 'crm.form.physicalPostalCode',
                            name: `${physicalAddressData.id}_physicalPostalCode`,
                            value: physicalAddressData.subFields[4].content,
                          }}
                          statesSwitchList={{
                            value:
                              physicalAddressData.customAttributes['region'] &&
                              physicalAddressData.customAttributes['region']
                                .provinceId,
                            regionType:
                              physicalAddressData.customAttributes['region'] &&
                              physicalAddressData.customAttributes['region']
                                .regiontype,
                            countryId: physicalAddressData.subFields[0].content,
                            name: `${physicalAddressData.id}_physicalStateId`,
                          }}
                          updateCustomAddressFieldData={
                            updateCustomAddressFieldData
                          }
                          addressData={physicalAddressData}
                          parentMethod={PHYSICAL_ADDRESS}
                          isLocal={false}
                        />
                      </div>
                    ),
                  )}

                {/* Get custom physical fields from user */}
                {customLabels &&
                  customLabels[PHYSICAL_ADDRESS].map(
                    (physicalAddressData, index) => (
                      <div key={index}>
                        <div className={styleClass.groupRow}>
                          <div className={styleClass.groupRowIcon}>
                            <EditLocationOutlinedIcon />
                          </div>
                          <div className={styleClass.groupRowTitle}>
                            {physicalAddressData.label}
                            <CloseIcon
                              onClick={() =>
                                setOpenDeleteCustomField(
                                  physicalAddressData.localId,
                                )
                              }
                              fontSize="small"
                              className={styleClass.customLabelCloseIcon}
                            />
                            <ConfirmDeleteCustomFieldPopup
                              deleteCustomLabel={() =>
                                deleteCustomLocalLabel(
                                  physicalAddressData.localId,
                                  PHYSICAL_ADDRESS,
                                )
                              }
                              openDeleteCustomField={
                                openDeleteCustomField ===
                                physicalAddressData.localId
                              }
                              setOpenDeleteCustomField={
                                setOpenDeleteCustomField
                              }
                            />
                          </div>
                        </div>
                        <AddressFields
                          formFields={physicalAddressData}
                          setFormFields={(updatedDate) => {
                            updateCustomAddressFieldData({
                              currentValue: updatedDate.physicalCountryId,
                              addressDataId: physicalAddressData.localId,
                              labelName: 'Country',
                              labelMethod: PHYSICAL_ADDRESS,
                              isLocal: true,
                              countryCode: updatedDate.physicalCountryCode,
                              countryId: updatedDate.physicalCountryId,
                              regionType: updatedDate.physicalRegionType,
                            })
                          }}
                          setCity={setCustomCity}
                          countryData={{
                            countryDataLabel: 'crm.form.physicalCountry',
                            countryDataName:
                              physicalAddressData.subFields[0].label,
                            countryDataValue: '',
                            propOfCountryCode: 'physicalCountryCode',
                            propOfRegionType: 'physicalRegionType',
                            propOfCountryId: 'physicalCountryId',
                          }}
                          placesNameAutocompleteFormsyData={{
                            labelId: 'crm.form.physicalStreetAddress',
                            placeholderId: 'crm.form.physicalStreetAddress',
                            cityProperty: 'physicalCityName',
                            variant: 'standard',
                            name: `custom_physicalStreetAddress1_${index}`,
                            value:
                              customLabels[PHYSICAL_ADDRESS][index][
                                'subFields'
                              ][1].content || '',
                            restriction:
                              physicalAddressData.subFields[0]
                                .physicalCountryCode,
                          }}
                          address2={{
                            labelId: 'crm.form.physicalStreetAddressLine2',
                            placeholderId:
                              'crm.form.physicalStreetAddressLine2',
                            variant: 'standard',
                            name: `custom_physicalStreetAddress2_${index}`,
                            value: '',
                          }}
                          physicalCityName={{
                            labelId: 'crm.form.physicalCityName',
                            placeholderId: 'crm.form.physicalCityName',
                            name: `custom_physicalCityName_${index}`,
                            value:
                              customLabels[PHYSICAL_ADDRESS][index][
                                'subFields'
                              ][3].content || '',
                          }}
                          physicalPostalCode={{
                            labelId: 'crm.form.physicalPostalCode',
                            placeholderId: 'crm.form.physicalPostalCode',
                            name: `custom_physicalPostalCode_${index}`,
                            value: '',
                          }}
                          statesSwitchList={{
                            value: '',
                            regionType:
                              physicalAddressData.subFields[0]
                                .physicalRegionType,
                            countryId:
                              physicalAddressData.subFields[0]
                                .physicalCountryId,
                            name: `custom_physicalStateId_${index}`,
                          }}
                          updateCustomAddressFieldData={
                            updateCustomAddressFieldData
                          }
                          addressData={physicalAddressData}
                          parentMethod={PHYSICAL_ADDRESS}
                          isLocal={true}
                        />
                      </div>
                    ),
                  )}

                <div className={styleClass.groupRow}>
                  <div className={styleClass.groupRowIcon}>
                    <ContactMailOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRowTitle}>
                    {formatMessage({
                      id: 'crm.form.mailingStreetAddress',
                    })}
                  </div>
                </div>
                <AddressFields
                  crmFields={crmFields}
                  formFields={formFields}
                  setFormFields={setFormFields}
                  setCity={setCity}
                  countryData={{
                    countryDataLabel: 'crm.form.mailingCountry',
                    countryDataName: 'mailingCountryId',
                    countryDataValue: crmFields.mailingCountry['id'],
                    propOfCountryCode: 'mailingCountryCode',
                    propOfRegionType: 'mailingRegionType',
                    propOfCountryId: 'mailingCountryId',
                  }}
                  placesNameAutocompleteFormsyData={{
                    labelId: 'crm.form.mailingStreetAddress',
                    placeholderId: 'crm.form.mailingStreetAddress',
                    cityProperty: 'mailingCityName',
                    variant: 'standard',
                    name: 'mailingStreetAddress1',
                    value: crmFields.mailingStreetAddress1,
                    restriction: formFields.mailingCountryCode,
                  }}
                  address2={{
                    labelId: 'crm.form.mailingStreetAddressLine2',
                    placeholderId: 'crm.form.mailingStreetAddressLine2',
                    variant: 'standard',
                    name: 'mailingStreetAddress2',
                    value: crmFields.mailingStreetAddress2,
                  }}
                  physicalCityName={{
                    labelId: 'crm.form.mailingCityName',
                    placeholderId: 'crm.form.mailingCityName',
                    name: 'mailingCityName',
                    value: formFields.mailingCityName,
                  }}
                  physicalPostalCode={{
                    labelId: 'crm.form.mailingPostalCode',
                    placeholderId: 'crm.form.mailingPostalCode',
                    name: 'mailingPostalCode',
                    value: crmFields.mailingPostalCode,
                  }}
                  statesSwitchList={{
                    value: crmFields.mailingState['id'],
                    regionType: formFields.mailingRegionType,
                    countryId: formFields.mailingCountryId,
                    name: 'mailingStateId',
                  }}
                />

                {/* Get custom mailing fields from backend */}
                {crmCustomfields[MAILING_ADDRESS] !== undefined &&
                  crmCustomfields[MAILING_ADDRESS].map((mailingAddressData) => (
                    <div key={mailingAddressData.id}>
                      <div className={styleClass.groupRow}>
                        <div className={styleClass.groupRowIcon}>
                          <EditLocationOutlinedIcon />
                        </div>
                        <div className={styleClass.groupRowTitle}>
                          {mailingAddressData.label}
                          <CloseIcon
                            onClick={() =>
                              setOpenDeleteCustomField(mailingAddressData.id)
                            }
                            fontSize="small"
                            className={styleClass.customLabelCloseIcon}
                          />
                          <ConfirmDeleteCustomFieldPopup
                            deleteCustomLabel={() =>
                              handleDeleteCRMCustomfield(
                                mailingAddressData.id,
                                MAILING_ADDRESS,
                              )
                            }
                            openDeleteCustomField={
                              openDeleteCustomField === mailingAddressData.id
                            }
                            setOpenDeleteCustomField={setOpenDeleteCustomField}
                          />
                        </div>
                      </div>
                      <AddressFields
                        formFields={mailingAddressData}
                        setFormFields={(updatedDate) => {
                          updateCustomAddressFieldData({
                            currentValue: updatedDate.physicalCountryId,
                            addressDataId: mailingAddressData.id,
                            labelName: 'Country',
                            labelMethod: MAILING_ADDRESS,
                            isLocal: false,
                            countryCode: updatedDate.physicalCountryCode,
                            countryId: updatedDate.physicalCountryId,
                            regionType: updatedDate.physicalRegionType,
                          })
                        }}
                        setCity={setCustomCity}
                        countryData={{
                          countryDataLabel: 'crm.form.physicalCountry',
                          countryDataName:
                            mailingAddressData.subFields[0].label,
                          countryDataValue:
                            mailingAddressData.subFields[0].content,
                          propOfCountryCode: 'physicalCountryCode',
                          propOfRegionType: 'physicalRegionType',
                          propOfCountryId: 'physicalCountryId',
                        }}
                        placesNameAutocompleteFormsyData={{
                          labelId: 'crm.form.mailingStreetAddress',
                          placeholderId: 'crm.form.mailingStreetAddress',
                          cityProperty: 'physicalCityName',
                          variant: 'standard',
                          name: `${mailingAddressData.id}_physicalStreetAddress1`,
                          value: mailingAddressData.subFields[1].content,
                          restriction:
                            mailingAddressData.customAttributes
                              .physicalCountryCode,
                        }}
                        address2={{
                          labelId: 'crm.form.mailingStreetAddressLine2',
                          placeholderId: 'crm.form.mailingStreetAddressLine2',
                          variant: 'standard',
                          name: `${mailingAddressData.id}_physicalStreetAddress2`,
                          value: mailingAddressData.subFields[2].content,
                        }}
                        physicalCityName={{
                          labelId: 'crm.form.mailingCityName',
                          placeholderId: 'crm.form.mailingCityName',
                          name: `${mailingAddressData.id}_physicalCityName`,
                          value: mailingAddressData.subFields[3].content,
                        }}
                        physicalPostalCode={{
                          labelId: 'crm.form.mailingPostalCode',
                          placeholderId: 'crm.form.mailingPostalCode',
                          name: `${mailingAddressData.id}_physicalPostalCode`,
                          value: mailingAddressData.subFields[4].content,
                        }}
                        statesSwitchList={{
                          value:
                            mailingAddressData.customAttributes['region'] &&
                            mailingAddressData.customAttributes['region']
                              .provinceId,
                          regionType:
                            mailingAddressData.customAttributes['region'] &&
                            mailingAddressData.customAttributes['region']
                              .regiontype,
                          countryId: mailingAddressData.subFields[0].content,
                          name: `${mailingAddressData.id}_physicalStateId`,
                        }}
                        updateCustomAddressFieldData={
                          updateCustomAddressFieldData
                        }
                        addressData={mailingAddressData}
                        parentMethod={MAILING_ADDRESS}
                        isLocal={false}
                      />
                    </div>
                  ))}
                {customLabels &&
                  customLabels[MAILING_ADDRESS].map(
                    (mailingAddressData, index) => (
                      <div key={index}>
                        <div className={styleClass.groupRow}>
                          <div className={styleClass.groupRowIcon}>
                            <ContactMailOutlinedIcon />
                          </div>
                          <div className={styleClass.groupRowTitle}>
                            {mailingAddressData.label}
                            <CloseIcon
                              onClick={() =>
                                setOpenDeleteCustomField(
                                  mailingAddressData.localId,
                                )
                              }
                              fontSize="small"
                              className={styleClass.customLabelCloseIcon}
                            />
                            <ConfirmDeleteCustomFieldPopup
                              deleteCustomLabel={() =>
                                deleteCustomLocalLabel(
                                  mailingAddressData.localId,
                                  MAILING_ADDRESS,
                                )
                              }
                              openDeleteCustomField={
                                openDeleteCustomField ===
                                mailingAddressData.localId
                              }
                              setOpenDeleteCustomField={
                                setOpenDeleteCustomField
                              }
                            />
                          </div>
                        </div>
                        <AddressFields
                          formFields={mailingAddressData}
                          setFormFields={(updatedDate) => {
                            updateCustomAddressFieldData({
                              currentValue: updatedDate.physicalCountryId,
                              addressDataId: mailingAddressData.localId,
                              labelName: 'Country',
                              labelMethod: MAILING_ADDRESS,
                              isLocal: true,
                              countryCode: updatedDate.physicalCountryCode,
                              countryId: updatedDate.physicalCountryId,
                              regionType: updatedDate.physicalRegionType,
                            })
                          }}
                          setCity={setCustomCity}
                          countryData={{
                            countryDataLabel: 'crm.form.physicalCountry',
                            countryDataName:
                              mailingAddressData.subFields[0].label,
                            countryDataValue: '',
                            propOfCountryCode: 'physicalCountryCode',
                            propOfRegionType: 'physicalRegionType',
                            propOfCountryId: 'physicalCountryId',
                          }}
                          placesNameAutocompleteFormsyData={{
                            labelId: 'crm.form.mailingStreetAddress',
                            placeholderId: 'crm.form.mailingStreetAddress',
                            cityProperty: 'physicalCityName',
                            variant: 'standard',
                            name: `custom_physicalStreetAddress1_${index}`,
                            value:
                              customLabels[MAILING_ADDRESS][index][
                                'subFields'
                              ][1].content || '',
                            restriction:
                              mailingAddressData.subFields[0]
                                .physicalCountryCode,
                          }}
                          address2={{
                            labelId: 'crm.form.mailingStreetAddressLine2',
                            placeholderId: 'crm.form.mailingStreetAddressLine2',
                            variant: 'standard',
                            name: `custom_physicalStreetAddress2_${index}`,
                            value: '',
                          }}
                          physicalCityName={{
                            labelId: 'crm.form.mailingCityName',
                            placeholderId: 'crm.form.mailingCityName',
                            name: `custom_physicalCityName_${index}`,
                            value:
                              customLabels[MAILING_ADDRESS][index][
                                'subFields'
                              ][3].content || '',
                          }}
                          physicalPostalCode={{
                            labelId: 'crm.form.mailingPostalCode',
                            placeholderId: 'crm.form.mailingPostalCode',
                            name: `custom_physicalPostalCode_${index}`,
                            value: '',
                          }}
                          statesSwitchList={{
                            value: '',
                            regionType:
                              mailingAddressData.subFields[0]
                                .physicalRegionType,
                            countryId:
                              mailingAddressData.subFields[0].physicalCountryId,
                            name: `custom_physicalStateId_${index}`,
                          }}
                          updateCustomAddressFieldData={
                            updateCustomAddressFieldData
                          }
                          addressData={mailingAddressData}
                          parentMethod={MAILING_ADDRESS}
                          isLocal={true}
                        />
                      </div>
                    ),
                  )}
                {/* Get custom shipping fields from backend */}
                {crmCustomfields &&
                  crmCustomfields[SHIPPING_ADDRESS] !== undefined &&
                  crmCustomfields[SHIPPING_ADDRESS].length > 0 && (
                    <div className={styleClass.groupRow}>
                      <div className={styleClass.groupRowIcon} />
                      <div className={styleClass.groupRowTitle}>
                        {formatMessage({
                          id: 'crm.form.shippingStreetAddress',
                        })}
                      </div>
                    </div>
                  )}
                {crmCustomfields[SHIPPING_ADDRESS] !== undefined &&
                  crmCustomfields[SHIPPING_ADDRESS].map(
                    (shippingAddressData) => (
                      <div key={shippingAddressData.id}>
                        <div className={styleClass.groupRow}>
                          <div className={styleClass.groupRowIcon}>
                            <EditLocationOutlinedIcon />
                          </div>
                          <div className={styleClass.groupRowTitle}>
                            {shippingAddressData.label}
                            <CloseIcon
                              onClick={() =>
                                setOpenDeleteCustomField(shippingAddressData.id)
                              }
                              fontSize="small"
                              className={styleClass.customLabelCloseIcon}
                            />
                            <ConfirmDeleteCustomFieldPopup
                              deleteCustomLabel={() =>
                                handleDeleteCRMCustomfield(
                                  shippingAddressData.id,
                                  SHIPPING_ADDRESS,
                                )
                              }
                              openDeleteCustomField={
                                openDeleteCustomField === shippingAddressData.id
                              }
                              setOpenDeleteCustomField={
                                setOpenDeleteCustomField
                              }
                            />
                          </div>
                        </div>
                        <AddressFields
                          formFields={shippingAddressData}
                          setFormFields={(updatedDate) => {
                            updateCustomAddressFieldData({
                              currentValue: updatedDate.physicalCountryId,
                              addressDataId: shippingAddressData.id,
                              labelName: 'Country',
                              labelMethod: SHIPPING_ADDRESS,
                              isLocal: false,
                              countryCode: updatedDate.physicalCountryCode,
                              countryId: updatedDate.physicalCountryId,
                              regionType: updatedDate.physicalRegionType,
                            })
                          }}
                          setCity={setCustomCity}
                          countryData={{
                            countryDataLabel: 'crm.form.physicalCountry',
                            countryDataName:
                              shippingAddressData.subFields[0].label,
                            countryDataValue:
                              shippingAddressData.subFields[0].content,
                            propOfCountryCode: 'physicalCountryCode',
                            propOfRegionType: 'physicalRegionType',
                            propOfCountryId: 'physicalCountryId',
                          }}
                          placesNameAutocompleteFormsyData={{
                            labelId: 'crm.form.physicalStreetAddress',
                            placeholderId: 'crm.form.physicalStreetAddress',
                            cityProperty: 'physicalCityName',
                            variant: 'standard',
                            name: `${shippingAddressData.id}_physicalStreetAddress1`,
                            value: shippingAddressData.subFields[1].content,
                            restriction:
                              shippingAddressData.customAttributes
                                .physicalCountryCode,
                          }}
                          address2={{
                            labelId: 'crm.form.physicalStreetAddressLine2',
                            placeholderId:
                              'crm.form.physicalStreetAddressLine2',
                            variant: 'standard',
                            name: `${shippingAddressData.id}_physicalStreetAddress2`,
                            value: shippingAddressData.subFields[2].content,
                          }}
                          physicalCityName={{
                            labelId: 'crm.form.physicalCityName',
                            placeholderId: 'crm.form.physicalCityName',
                            name: `${shippingAddressData.id}_physicalCityName`,
                            value: shippingAddressData.subFields[3].content,
                          }}
                          physicalPostalCode={{
                            labelId: 'crm.form.physicalPostalCode',
                            placeholderId: 'crm.form.physicalPostalCode',
                            name: `${shippingAddressData.id}_physicalPostalCode`,
                            value: shippingAddressData.subFields[4].content,
                          }}
                          statesSwitchList={{
                            value:
                              shippingAddressData.customAttributes['region'] &&
                              shippingAddressData.customAttributes['region']
                                .provinceId,
                            regionType:
                              shippingAddressData.customAttributes['region'] &&
                              shippingAddressData.customAttributes['region']
                                .regiontype,
                            countryId: shippingAddressData.subFields[0].content,
                            name: `${shippingAddressData.id}_physicalStateId`,
                          }}
                          updateCustomAddressFieldData={
                            updateCustomAddressFieldData
                          }
                          addressData={shippingAddressData}
                          parentMethod={SHIPPING_ADDRESS}
                          isLocal={false}
                        />
                      </div>
                    ),
                  )}
                {customLabels && customLabels[SHIPPING_ADDRESS].length > 0 && (
                  <div className={styleClass.groupRow}>
                    <div className={styleClass.groupRowIcon}>
                      <ContactMailOutlinedIcon />
                    </div>
                    <div className={styleClass.groupRowTitle}>
                      {formatMessage({
                        id: 'crm.form.shippingStreetAddress',
                      })}
                    </div>
                  </div>
                )}
                {customLabels &&
                  customLabels[SHIPPING_ADDRESS].map(
                    (shippingAddressData, index) => (
                      <div key={index}>
                        <div className={styleClass.groupRow}>
                          <div className={styleClass.groupRowIcon} />
                          <div className={styleClass.groupRowTitle}>
                            {shippingAddressData.label}
                            <CloseIcon
                              onClick={() =>
                                setOpenDeleteCustomField(
                                  shippingAddressData.localId,
                                )
                              }
                              fontSize="small"
                              className={styleClass.customLabelCloseIcon}
                            />
                            <ConfirmDeleteCustomFieldPopup
                              deleteCustomLabel={() =>
                                deleteCustomLocalLabel(
                                  shippingAddressData.localId,
                                  SHIPPING_ADDRESS,
                                )
                              }
                              openDeleteCustomField={
                                openDeleteCustomField ===
                                shippingAddressData.localId
                              }
                              setOpenDeleteCustomField={
                                setOpenDeleteCustomField
                              }
                            />
                          </div>
                        </div>
                        <AddressFields
                          formFields={shippingAddressData}
                          setFormFields={(updatedDate) => {
                            updateCustomAddressFieldData({
                              currentValue: updatedDate.physicalCountryId,
                              addressDataId: shippingAddressData.localId,
                              labelName: 'Country',
                              labelMethod: SHIPPING_ADDRESS,
                              isLocal: true,
                              countryCode: updatedDate.physicalCountryCode,
                              countryId: updatedDate.physicalCountryId,
                              regionType: updatedDate.physicalRegionType,
                            })
                          }}
                          setCity={setCustomCity}
                          countryData={{
                            countryDataLabel: 'crm.form.physicalCountry',
                            countryDataName:
                              shippingAddressData.subFields[0].label,
                            countryDataValue: '',
                            propOfCountryCode: 'physicalCountryCode',
                            propOfRegionType: 'physicalRegionType',
                            propOfCountryId: 'physicalCountryId',
                          }}
                          placesNameAutocompleteFormsyData={{
                            labelId: 'crm.form.physicalStreetAddress',
                            placeholderId: 'crm.form.physicalStreetAddress',
                            cityProperty: 'physicalCityName',
                            variant: 'standard',
                            name: `custom_physicalStreetAddress1_${index}`,
                            value:
                              customLabels[SHIPPING_ADDRESS][index][
                                'subFields'
                              ][1].content || '',
                            restriction:
                              shippingAddressData.subFields[0]
                                .physicalCountryCode,
                          }}
                          address2={{
                            labelId: 'crm.form.physicalStreetAddressLine2',
                            placeholderId:
                              'crm.form.physicalStreetAddressLine2',
                            variant: 'standard',
                            name: `custom_physicalStreetAddress2_${index}`,
                            value: '',
                          }}
                          physicalCityName={{
                            labelId: 'crm.form.physicalCityName',
                            placeholderId: 'crm.form.physicalCityName',
                            name: `custom_physicalCityName_${index}`,
                            value:
                              customLabels[SHIPPING_ADDRESS][index][
                                'subFields'
                              ][3].content || '',
                          }}
                          physicalPostalCode={{
                            labelId: 'crm.form.physicalPostalCode',
                            placeholderId: 'crm.form.physicalPostalCode',
                            name: `custom_physicalPostalCode_${index}`,
                            value: '',
                          }}
                          statesSwitchList={{
                            value: '',
                            regionType:
                              shippingAddressData.subFields[0]
                                .physicalRegionType,
                            countryId:
                              shippingAddressData.subFields[0]
                                .physicalCountryId,
                            name: `custom_physicalStateId_${index}`,
                          }}
                          updateCustomAddressFieldData={
                            updateCustomAddressFieldData
                          }
                          addressData={shippingAddressData}
                          parentMethod={SHIPPING_ADDRESS}
                          isLocal={true}
                        />
                      </div>
                    ),
                  )}

                {/* Get custom billing fields from backend */}
                {crmCustomfields &&
                  crmCustomfields[BILLING_ADDRESS] !== undefined &&
                  crmCustomfields[BILLING_ADDRESS].length > 0 && (
                    <div className={styleClass.groupRow}>
                      <div className={styleClass.groupRowIcon} />
                      <div className={styleClass.groupRowTitle}>
                        {formatMessage({
                          id: 'crm.form.billingStreetAddress',
                        })}
                      </div>
                    </div>
                  )}
                {crmCustomfields[BILLING_ADDRESS] !== undefined &&
                  crmCustomfields[BILLING_ADDRESS].map((billingAddressData) => (
                    <div key={billingAddressData.id}>
                      <div className={styleClass.groupRow}>
                        <div className={styleClass.groupRowIcon}>
                          <EditLocationOutlinedIcon />
                        </div>
                        <div className={styleClass.groupRowTitle}>
                          {billingAddressData.label}
                          <CloseIcon
                            onClick={() =>
                              setOpenDeleteCustomField(billingAddressData.id)
                            }
                            fontSize="small"
                            className={styleClass.customLabelCloseIcon}
                          />
                          <ConfirmDeleteCustomFieldPopup
                            deleteCustomLabel={() =>
                              handleDeleteCRMCustomfield(
                                billingAddressData.id,
                                BILLING_ADDRESS,
                              )
                            }
                            openDeleteCustomField={
                              openDeleteCustomField === billingAddressData.id
                            }
                            setOpenDeleteCustomField={setOpenDeleteCustomField}
                          />
                        </div>
                      </div>
                      <AddressFields
                        formFields={billingAddressData}
                        setFormFields={(updatedDate) => {
                          updateCustomAddressFieldData({
                            currentValue: updatedDate.physicalCountryId,
                            addressDataId: billingAddressData.id,
                            labelName: 'Country',
                            labelMethod: BILLING_ADDRESS,
                            isLocal: false,
                            countryCode: updatedDate.physicalCountryCode,
                            countryId: updatedDate.physicalCountryId,
                            regionType: updatedDate.physicalRegionType,
                          })
                        }}
                        setCity={setCustomCity}
                        countryData={{
                          countryDataLabel: 'crm.form.physicalCountry',
                          countryDataName:
                            billingAddressData.subFields[0].label,
                          countryDataValue:
                            billingAddressData.subFields[0].content,
                          propOfCountryCode: 'physicalCountryCode',
                          propOfRegionType: 'physicalRegionType',
                          propOfCountryId: 'physicalCountryId',
                        }}
                        placesNameAutocompleteFormsyData={{
                          labelId: 'crm.form.physicalStreetAddress',
                          placeholderId: 'crm.form.physicalStreetAddress',
                          cityProperty: 'physicalCityName',
                          variant: 'standard',
                          name: `${billingAddressData.id}_physicalStreetAddress1`,
                          value: billingAddressData.subFields[1].content,
                          restriction:
                            billingAddressData.customAttributes
                              .physicalCountryCode,
                        }}
                        address2={{
                          labelId: 'crm.form.physicalStreetAddressLine2',
                          placeholderId: 'crm.form.physicalStreetAddressLine2',
                          variant: 'standard',
                          name: `${billingAddressData.id}_physicalStreetAddress2`,
                          value: billingAddressData.subFields[2].content,
                        }}
                        physicalCityName={{
                          labelId: 'crm.form.physicalCityName',
                          placeholderId: 'crm.form.physicalCityName',
                          name: `${billingAddressData.id}_physicalCityName`,
                          value: billingAddressData.subFields[3].content,
                        }}
                        physicalPostalCode={{
                          labelId: 'crm.form.physicalPostalCode',
                          placeholderId: 'crm.form.physicalPostalCode',
                          name: `${billingAddressData.id}_physicalPostalCode`,
                          value: billingAddressData.subFields[4].content,
                        }}
                        statesSwitchList={{
                          value:
                            billingAddressData.customAttributes['region'] &&
                            billingAddressData.customAttributes['region']
                              .provinceId,
                          regionType:
                            billingAddressData.customAttributes['region'] &&
                            billingAddressData.customAttributes['region']
                              .regiontype,
                          countryId: billingAddressData.subFields[0].content,
                          name: `${billingAddressData.id}_physicalStateId`,
                        }}
                        updateCustomAddressFieldData={
                          updateCustomAddressFieldData
                        }
                        addressData={billingAddressData}
                        parentMethod={BILLING_ADDRESS}
                        isLocal={false}
                      />
                    </div>
                  ))}
                {customLabels && customLabels[BILLING_ADDRESS].length > 0 && (
                  <div className={styleClass.groupRow}>
                    <div className={styleClass.groupRowIcon}>
                      <ContactMailOutlinedIcon />
                    </div>
                    <div className={styleClass.groupRowTitle}>
                      {formatMessage({
                        id: 'crm.form.billingStreetAddress',
                      })}
                    </div>
                  </div>
                )}
                {customLabels &&
                  customLabels[BILLING_ADDRESS].map(
                    (billingAddressData, index) => (
                      <div key={index}>
                        <div className={styleClass.groupRow}>
                          <div className={styleClass.groupRowIcon} />
                          <div className={styleClass.groupRowTitle}>
                            {billingAddressData.label}
                            <CloseIcon
                              onClick={() =>
                                setOpenDeleteCustomField(
                                  billingAddressData.localId,
                                )
                              }
                              fontSize="small"
                              className={styleClass.customLabelCloseIcon}
                            />
                            <ConfirmDeleteCustomFieldPopup
                              deleteCustomLabel={() =>
                                deleteCustomLocalLabel(
                                  billingAddressData.localId,
                                  BILLING_ADDRESS,
                                )
                              }
                              openDeleteCustomField={
                                openDeleteCustomField ===
                                billingAddressData.localId
                              }
                              setOpenDeleteCustomField={
                                setOpenDeleteCustomField
                              }
                            />
                          </div>
                        </div>
                        <AddressFields
                          formFields={billingAddressData}
                          setFormFields={(updatedDate) => {
                            updateCustomAddressFieldData({
                              currentValue: updatedDate.physicalCountryId,
                              addressDataId: billingAddressData.localId,
                              labelName: 'Country',
                              labelMethod: BILLING_ADDRESS,
                              isLocal: true,
                              countryCode: updatedDate.physicalCountryCode,
                              countryId: updatedDate.physicalCountryId,
                              regionType: updatedDate.physicalRegionType,
                            })
                          }}
                          setCity={setCustomCity}
                          countryData={{
                            countryDataLabel: 'crm.form.physicalCountry',
                            countryDataName:
                              billingAddressData.subFields[0].label,
                            countryDataValue: '',
                            propOfCountryCode: 'physicalCountryCode',
                            propOfRegionType: 'physicalRegionType',
                            propOfCountryId: 'physicalCountryId',
                          }}
                          placesNameAutocompleteFormsyData={{
                            labelId: 'crm.form.physicalStreetAddress',
                            placeholderId: 'crm.form.physicalStreetAddress',
                            cityProperty: 'physicalCityName',
                            variant: 'standard',
                            name: `custom_physicalStreetAddress1_${index}`,
                            value:
                              customLabels[BILLING_ADDRESS][index][
                                'subFields'
                              ][1].content || '',
                            restriction:
                              billingAddressData.subFields[0]
                                .physicalCountryCode,
                          }}
                          address2={{
                            labelId: 'crm.form.physicalStreetAddressLine2',
                            placeholderId:
                              'crm.form.physicalStreetAddressLine2',
                            variant: 'standard',
                            name: `custom_physicalStreetAddress2_${index}`,
                            value: '',
                          }}
                          physicalCityName={{
                            labelId: 'crm.form.physicalCityName',
                            placeholderId: 'crm.form.physicalCityName',
                            name: `custom_physicalCityName_${index}`,
                            value:
                              customLabels[BILLING_ADDRESS][index][
                                'subFields'
                              ][3].content || '',
                          }}
                          physicalPostalCode={{
                            labelId: 'crm.form.physicalPostalCode',
                            placeholderId: 'crm.form.physicalPostalCode',
                            name: `custom_physicalPostalCode_${index}`,
                            value: '',
                          }}
                          statesSwitchList={{
                            value: '',
                            regionType:
                              billingAddressData.subFields[0]
                                .physicalRegionType,
                            countryId:
                              billingAddressData.subFields[0].physicalCountryId,
                            name: `custom_physicalStateId_${index}`,
                          }}
                          updateCustomAddressFieldData={
                            updateCustomAddressFieldData
                          }
                          addressData={billingAddressData}
                          parentMethod={BILLING_ADDRESS}
                          isLocal={true}
                        />
                      </div>
                    ),
                  )}
                <div className={styleClass.groupRow}>
                  <div className={styleClass.groupRowIcon}>
                    <WorkOutlineOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRowTitle}>
                    {formatMessage({
                      id: 'crm.form.employerInformation',
                    })}
                  </div>
                </div>
                <div className={styleClass.formRow}>
                  <div className={styleClass.formRowIcon} />
                  <div className={styleClass.formRowInputs}>
                    <div className={styleClass.formRowItemTwo}>
                      <TextInput
                        margin="dense"
                        containerClassName="MuiFormControl-fullWidth"
                        labelId="crm.form.companyName"
                        placeholderId="crm.form.companyName"
                        variant="standard"
                        fullWidth
                        name="companyName"
                        value={crmFields.companyName}
                      />
                    </div>
                  </div>
                </div>

                <div className={styleClass.formRow}>
                  <div className={styleClass.formRowIcon} />
                  <div className={styleClass.formRowInputs}>
                    <div
                      className={clsx(
                        styleClass.formRowItemOne,
                        styleClass.formRowLeftItem,
                      )}
                    >
                      <OccupationList
                        name="jobTitle"
                        formFields={formFields}
                        setFormFields={setFormFields}
                        label={formatMessage({
                          id: 'crm.form.jobTitle',
                        })}
                      />
                    </div>

                    <div className={styleClass.formRowItemOne}>
                      <TextInput
                        margin="dense"
                        containerClassName="MuiFormControl-fullWidth"
                        labelId="crm.form.jobDepartment"
                        placeholderId="crm.form.jobDepartment"
                        variant="standard"
                        fullWidth
                        name="jobDepartment"
                        value={crmFields.jobDepartment}
                      />
                    </div>
                  </div>
                </div>

                <div className={styleClass.groupRow}>
                  <div className={styleClass.groupRowIcon}>
                    <ShareOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRowTitle}>
                    {formatMessage({
                      id: 'crm.form.socialInformation',
                    })}
                    <CustomSocialForm saveCustomLabel={saveCustomLabel} />
                  </div>
                </div>
                <div className={styleClass.formRow}>
                  <div className={styleClass.formRowIcon} />
                  <div className={styleClass.formRowInputs}>
                    <div
                      className={clsx(
                        styleClass.formRowItemOne,
                        styleClass.formRowLeftItem,
                      )}
                    >
                      <TextInput
                        margin="dense"
                        containerClassName="MuiFormControl-fullWidth"
                        labelId="crm.form.facebookProfile"
                        placeholderId="crm.form.facebookProfile"
                        variant="standard"
                        fullWidth
                        name="facebookProfile"
                        value={crmFields.facebookProfile}
                        validations="isUrl"
                        validationErrors={{
                          isUrl: formatMessage({
                            id: 'crm.form.validation.url',
                          }),
                        }}
                      />
                    </div>

                    <div className={styleClass.formRowItemOne}>
                      <TextInput
                        margin="dense"
                        containerClassName="MuiFormControl-fullWidth"
                        labelId="crm.form.twitterProfile"
                        placeholderId="crm.form.twitterProfile"
                        variant="standard"
                        fullWidth
                        name="twitterProfile"
                        value={crmFields.twitterProfile}
                        validations="isUrl"
                        validationErrors={{
                          isUrl: formatMessage({
                            id: 'crm.form.validation.url',
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className={styleClass.formRow}>
                  <div className={styleClass.formRowIcon} />
                  <div className={styleClass.formRowInputs}>
                    <div
                      className={clsx(
                        styleClass.formRowItemOne,
                        styleClass.formRowLeftItem,
                      )}
                    >
                      <TextInput
                        margin="dense"
                        containerClassName="MuiFormControl-fullWidth"
                        labelId="crm.form.linkedinProfile"
                        placeholderId="crm.form.linkedinProfile"
                        variant="standard"
                        fullWidth
                        name="linkedinProfile"
                        value={crmFields.linkedinProfile}
                        validations="isUrl"
                        validationErrors={{
                          isUrl: formatMessage({
                            id: 'crm.form.validation.url',
                          }),
                        }}
                      />
                    </div>

                    <div className={styleClass.formRowItemOne}>
                      <TextInput
                        margin="dense"
                        containerClassName="MuiFormControl-fullWidth"
                        labelId="crm.form.lineProfile"
                        placeholderId="crm.form.lineProfile"
                        variant="standard"
                        fullWidth
                        name="lineProfile"
                        value={crmFields.lineProfile}
                      />
                    </div>
                  </div>
                </div>
                <div className={styleClass.customFieldStyle}>
                  {crmCustomfields[SOCIAL_INFORMATION] !== undefined &&
                    crmCustomfields[SOCIAL_INFORMATION].map(
                      (socialField, index) => (
                        <CustomFieldForm
                          key={index}
                          index={index}
                          customField={socialField}
                          updateCustomFieldsContentData={
                            updateCustomFieldsContentData
                          }
                          parentMethod={SOCIAL_INFORMATION}
                          deleteCustomLabel={() =>
                            handleDeleteCRMCustomfield(
                              socialField.id,
                              SOCIAL_INFORMATION,
                            )
                          }
                          isLocal={false}
                          validations={
                            socialField.customAttributes['labelType'] !==
                              'Other' && 'isUrl'
                          }
                          validationErrors={{
                            isUrl: formatMessage({
                              id: 'crm.form.validation.url',
                            }),
                          }}
                        />
                      ),
                    )}
                  {customLabels &&
                    customLabels[SOCIAL_INFORMATION].map(
                      (socialItem, index) => (
                        <div
                          key={index}
                          className={styleClass.customLabelWrapper}
                        >
                          <CustomFieldForm
                            index={index}
                            customField={socialItem}
                            updateCustomFieldsContentData={
                              updateCustomFieldsContentData
                            }
                            parentMethod={SOCIAL_INFORMATION}
                            deleteCustomLabel={() =>
                              deleteCustomLocalLabel(
                                socialItem.localId,
                                SOCIAL_INFORMATION,
                              )
                            }
                            isLocal={true}
                            validations="isUrl"
                            validationErrors={{
                              isUrl: formatMessage({
                                id: 'crm.form.validation.url',
                              }),
                            }}
                          />
                        </div>
                      ),
                    )}
                </div>
              </div>
            </div>
          </DialogContent>

          <DialogActions className={styleClass.footerSection}>
            <div></div>

            <div>
              <CancelButton
                className={styleClass.actionBtn}
                onClick={openOrCloseEditDetailsDialog}
              >
                <FormattedMessage id="action.cancel" />
              </CancelButton>
              <PrimaryButton
                type="submit"
                className={styleClass.actionBtn}
                disabled={
                  dialogState.isDisabledBtn ||
                  !dialogState.isFormValid ||
                  isDisabledForm
                }
              >
                <FormattedMessage id="action.save" />
              </PrimaryButton>
            </div>
          </DialogActions>
        </Formsy>
      </Dialog>
    </>
  )
}
